import { useTheme } from '@emotion/react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import {
  Button,
  Card,
  Collapse,
  Dialog,
  FormControlLabel,
  Grid,
  IconButton,
  Popover,
  Stack,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Typography,
  useMediaQuery,
} from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import { Box } from '@mui/system';
import { visuallyHidden } from '@mui/utils';
import Avatar from 'antd/es/avatar/avatar';
import { getApiCall, postApiCall } from 'api/apiService';
import Dp from 'assets/dummy/buy.jpg';
import BlueTick from 'assets/icons/blueTick.svg';
import { ReactComponent as Call } from 'assets/icons/call.svg';
import { ReactComponent as Messageicon } from 'assets/icons/Chat.svg';
import Monetize from 'assets/icons/dollar.svg';
import AppHeader from 'component/AppHeader/AppHeader';
import { checkbox_style } from 'component/ContactTab/Table.style';
import CountdownTimer from 'component/CountDownTimer/CountdownTimer';
import Moxochat from 'component/Moxochat/Moxochat';
import { imageCont } from 'component/OwnerCard/LiveActivityFeed.style';
import PropertyTimer, { PauseIcon } from 'component/PropertyTime/PropertyTimer';
import { Ended, Stage1, Stage2, Stage2Final } from 'component/Common/StageTags';
import {
  GET_SOLICITOR_USERLIST,
  SOLICITOR_REAL_TIME,
  STORE_ETA,
  REQUEST_SOLICITOR_USERLIST,
  CANCELLED_SOLICITOR_USERLIST,
  LOGGED_FROM,
  USER_MAIL_ID,
  SOLICITOR_CREATE_BINDER_BEFORE_ACCEPT,
  SOLICITOR_CREATE_BINDER,
  SOLICITOR_LINK_TO_BUYER,
  SOLICITOR_CREATE_BINDER_AFTER_ACCEPT,
  SOLICITOR_REVOKE,
  SOLICITOR_CREATE_SOL_BUYER_BINDER,
} from 'constant/app.config';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import moment from 'moment/moment';
import React, { createContext, useEffect, useRef, useState } from 'react';
import { fontsize10, poppins400 } from 'theme/common.style';
import Message from '../Message/Message';
import Swal from 'sweetalert2';
import {
  Calender,
  CallNew,
  Clock,
  ContractReceipt,
  EyeIcon,
  HomeIcon,
  InfoIcon,
  MessageNew,
  PublishedIcon,
  RayWhite,
  Receipt,
  Timer,
  Warning,
} from './PublishedIcon';
import BuyerSolicitorStatusPopup from './BuyerSolicitorStatusPopup';
import Moxocall from 'modules/public/Moxocall/Moxocall';
import Loading from 'assets/images/loading.png';
import ProfileSettings from 'component/AccountMenu/ProfileSetting';
import { ReactComponent as Filemanagericon } from 'assets/svg/Paper.svg';
import DocumentHub from 'component/FileManager/DocumentHub';
import HelpCenterHome from 'component/Common/Helpdesk';
import AgencyBadge from 'component/Common/AgencyBadge';

dayjs.extend(timezone);
dayjs.extend(utc);

const datacontextsoli = createContext();

const BuyerSolicitor = () => {
  const [currentSydneyDate, setCurrentSydneyDate] = useState(
    dayjs().tz('Australia/Sydney')
  );
  const minDate = currentSydneyDate;

  useEffect(() => {
    const interval = setInterval(() => {
      const newSydneyDate = dayjs().tz('Australia/Sydney');
      setCurrentSydneyDate(newSydneyDate);
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  const [realTimeLog, setRealTimeLog] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [message, setMessage] = useState(false);
  const [dashormes, setDashormes] = React.useState(false);
  const [changestab, setChangestab] = useState(false);
  const [selectedcategorybuying, setSelectedcategorybuying] = useState('');
  const [openarrow, setOpenarrow] = useState('');
  const [openarrowindex, setOpenarrowindex] = useState(null);
  const [buyerDropdown, setBuyerDropdown] = useState(null);
  const [sellerTable, setSellerTable] = useState(false);
  const [buyerTable, setBuyerTable] = useState(false);
  const [buyerActiveList, setBuyerActiveList] = useState([]);
  const [buyerInactiveList, setBuyerInactiveList] = useState([]);
  const [requestedList, setRequestedList] = useState([]);
  const [cancelledList, setCancelledList] = useState([]);
  const [binderId, setBinderId] = useState('');
  const [currentBinder, setCurrentBinder] = useState();
  const data1 = localStorage.getItem('userDetail');
  const userDetail = JSON.parse(data1);
  const name = userDetail?.userName;
  const surname = userDetail?.userSurName;
  const [isOpenFileManager, setIsOpenFileManager] = useState(false);
  const [isOpenFileManagerDialog, setIsOpenFileManagerDialog] = useState(false);
  const [isFromBuyerSolicitor, setIsFromBuyerSolicitor] = useState(true);
  const [isFromVendorSolicitor, setIsFromVendorSolicitor] = useState(false);
  const [isFileView, setIsFileView] = useState(false);
  const [selectedPropertyAddress, setSelectedPropertyAddress] = useState('');
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [loadingRequests, setLoadingRequests] = useState(false);
  const [loadingCancelled, setLoadingCancelled] = useState(false);
  const [statustextpopup, setStatustextpopup] = useState('');
  const cardScrollRef = useRef(null);
  const scrollPositionRef = useRef(0);

  const [propertyId, setPropertyId] = useState('');
  const [buyerId, setBuyerId] = useState('');
  const [address, setAddress] = useState('');
  const [createdDate, setCreatedDate] = useState('');
  const [updatedDate, setUpdatedDate] = useState('');

  const [showMessage, setShowMessage] = useState(false);
  const [messagedata, setMessagedata] = useState(null);
  const [openprofile, setOpenprofile] = useState(false);
  const [openhelp, setOpenhelp] = useState(false);
  const handleHelpCenterBack = () => {
    setDashormes(true);
    setChangestab(false);
    setMessage(false);
    setShowMessage(false);
    setOpenprofile(false);
    setOpenhelp(false);
  };

  const handleOpenHelpCenter = () => {
    setDashormes(false);
    setChangestab(false);
    setMessage(false);
    setShowMessage(false);
    setOpenprofile(false);
    setOpenhelp(true);
  };
  const anchorRef = useRef(null);
  const [fileManagerBuyerId, setFileManagerBuyerId] = useState(null);
  useEffect(() => {
    if (showMessage == false) {
      setMessagedata(null);
    }
  }, [showMessage]);

  useEffect(() => {
    if (!isOpenFileManager) {
      setTimeout(() => {
        if (cardScrollRef.current) {
          cardScrollRef.current.scrollTop = scrollPositionRef.current + 100;
        }
      }, 300);
    }
  }, [isOpenFileManager]);

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));

  const headCells = [
    {
      id: 'name',
      numeric: false,
      disablePadding: true,
      label: 'Name',
    },
    {
      id: 'contact',
      numeric: true,
      disablePadding: false,
      label: 'Contact',
    },
    {
      id: 'Linked Partner',
      numeric: true,
      disablePadding: false,
      label: 'Linked Partner',
    },
    {
      id: 'Residental Address',
      numeric: true,
      disablePadding: false,
      label: 'Residental Address',
    },
    {
      id: 'Legal Buying Entity',
      numeric: true,
      disablePadding: false,
      label: 'Legal Buying Entity',
    },
    {
      id: null,
      numeric: true,
      disablePadding: false,
      label: null,
    },
  ];

  const buyingheadCells = [
    {
      id: 'Property Address',
      numeric: false,
      disablePadding: true,
      label: 'Property Address',
    },
    {
      id: 'Buyer Status',
      numeric: true,
      disablePadding: false,
      label: 'Buyer Status',
    },
    {
      id: 'Contract Status',
      numeric: true,
      disablePadding: false,
      label: 'Contract Status',
    },
    {
      id: 'Contract ETA',
      numeric: true,
      disablePadding: false,
      label: 'Contract ETA',
    },
    {
      id: '66W Status',
      numeric: true,
      disablePadding: false,
      label: 's66W Status',
    },
    {
      id: '66W ETA',
      numeric: true,
      disablePadding: false,
      label: 's66W ETA',
    },
    {
      id: 'Campaign Timer',
      numeric: true,
      disablePadding: false,
      label: 'Campaign Timer',
    },
    {
      id: 'Agent',
      numeric: true,
      disablePadding: false,
      label: 'Agent',
    },
    {
      id: 'Vendor Solicitor',
      numeric: true,
      disablePadding: false,
      label: 'Vendor Solicitor',
    },
    {
      id: 'File Manager',
      numeric: true,
      disablePadding: false,
      label: 'File Manager',
    },
  ];

  const sellingbuyerheadCells = [
    {
      id: 'Property Address',
      numeric: false,
      disablePadding: true,
      label: 'Property Address',
    },
    {
      id: 'Buyer Status',
      numeric: true,
      disablePadding: false,
      label: 'Buyer Status',
    },
    {
      id: 'Contract Status',
      numeric: true,
      disablePadding: false,
      label: 'Contract Status',
    },
    {
      id: '66W Status',
      numeric: true,
      disablePadding: false,
      label: 's66W Status',
    },
    {
      id: 'Buyer Solicitor',
      numeric: true,
      disablePadding: false,
      label: 'Buyer Solicitor',
    },
  ];

  const Sellingfirstcells = [
    {
      id: 'Property Address',
      numeric: false,
      disablePadding: true,
      label: 'Property Address',
    },
    {
      id: 'Campaign Timer',
      numeric: true,
      disablePadding: false,
      label: 'Campaign Timer',
    },
    {
      id: null,
      numeric: true,
      disablePadding: false,
      label: null,
    },
    {
      id: null,
      numeric: true,
      disablePadding: false,
      label: null,
    },
    {
      id: null,
      numeric: true,
      disablePadding: false,
      label: null,
    },
    {
      id: null,
      numeric: true,
      disablePadding: false,
      label: null,
    },
    {
      id: null,
      numeric: true,
      disablePadding: false,
      label: null,
    },
    {
      id: null,
      numeric: true,
      disablePadding: false,
      label: null,
    },
    {
      id: 'Agent',
      numeric: true,
      disablePadding: false,
      label: 'Agent',
    },
    {
      id: 'File Manager',
      numeric: true,
      disablePadding: false,
      label: 'File Manager',
    },
  ];

  const handleRowClickTwo = (rowId, section) => {
    const key = `${section}-${rowId}`;
    setBuyerTable((prevState) => ({
      ...prevState,
      [key]: !prevState[key],
    }));
    setSellerTable(false);
  };

  const solicitorId = userDetail?.userId;

  const Getuserlist = () => {
    getApiCall(
      GET_SOLICITOR_USERLIST + '/' + `${solicitorId}` + '/Buying'
    ).then((res) => {
      setBuyerActiveList(res?.data?.userListActive);
      setBuyerInactiveList(res?.data?.userListInActive);
    });
  };
  const Getrequestuserlist = () => {
    const token = localStorage.getItem('accessToken');
    const accessToken = 'Bearer ' + token;
    const headers = {
      'Content-Type': 'application/json',
      Authorization: accessToken,
    };

    getApiCall(REQUEST_SOLICITOR_USERLIST, { headers }).then((res) => {
      setRequestedList(res?.data?.userList);
    });
  };
  const Getcancelleduserlist = () => {
    const token = localStorage.getItem('accessToken');
    const accessToken = 'Bearer ' + token;
    const headers = {
      'Content-Type': 'application/json',
      Authorization: accessToken,
    };

    getApiCall(CANCELLED_SOLICITOR_USERLIST, { headers }).then((res) => {
      setCancelledList(res?.data?.userList);
    });
  };

  const recallAllUserLists = () => {
    Getuserlist();
    Getrequestuserlist();
    Getcancelleduserlist();
  };

  const handleAccept = (buyerId, solicitorId, buyerName, buyerSurName) => {
    const data = {
      buyerId: buyerId,
      isLinked: 1,
      linkedStatus: 'Approved',
    };

    postApiCall(SOLICITOR_LINK_TO_BUYER, data)
      .then((response) => {
        const { status, message } = response?.data;

        if (status == 1) {
          Getuserlist();
          Getrequestuserlist();
          Getcancelleduserlist();
          handleAfterAccept(buyerId, solicitorId);
          Swal.fire({
            icon: 'success',
            title: 'Request Approved',
            html: `You have accepted the legal discussion request for  
          <span style="font-weight: 550; font-family: 'Poppins'; color: #666666;">
            ${buyerName + ' ' + buyerSurName}
          </span>  
          at <span style="font-weight: 550; font-family: 'Poppins'; color: #666666;">
            ${dayjs().tz('Australia/Sydney').format('HH:mm')}
          </span>  
          on <span style="font-weight: 550; font-family: 'Poppins'; color: #666666;">
            ${dayjs().tz('Australia/Sydney').format('DD MMM YYYY')}
          </span>.`,
            confirmButtonText: 'Close',
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: message,
            confirmButtonText: 'Close',
          });
        }
      })
      .catch((err) => {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Something went wrong',
          confirmButtonText: 'Close',
        });
      });
  };

  const handleAfterAccept = (buyerId, solicitorId) => {
    const data = {
      userId: buyerId,
      solicitorId: solicitorId,
    };

    postApiCall(SOLICITOR_CREATE_BINDER_AFTER_ACCEPT, data)
      .then((response) => {
        const { status } = response?.data;

        if (status == 1) {
          Getuserlist();
          Getrequestuserlist();
          Getcancelleduserlist();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const handleDecline = (buyerId, buyerName, buyerSurName) => {
    const data = {
      buyerId: buyerId,
      isLinked: 0,
      linkedStatus: 'Declined',
    };

    postApiCall(SOLICITOR_LINK_TO_BUYER, data)
      .then((response) => {
        const { status, message } = response?.data;

        if (status == 1) {
          Swal.fire({
            icon: 'success',
            title: 'Request declined',
            html: `You have declined the legal discussion request for  
          <span style="font-weight: 550; font-family: 'Poppins'; color: #666666;">
            ${buyerName + ' ' + buyerSurName}
          </span>  
          at <span style="font-weight: 550; font-family: 'Poppins'; color: #666666;">
            ${dayjs().tz('Australia/Sydney').format('HH:mm')}
          </span>  
          on <span style="font-weight: 550; font-family: 'Poppins'; color: #666666;">
            ${dayjs().tz('Australia/Sydney').format('DD MMM YYYY')}
          </span>.`,
          });

          Getuserlist();
          Getrequestuserlist();
          Getcancelleduserlist();
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: message,
            confirmButtonText: 'Close',
          });
        }
      })
      .catch((err) => {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Something went wrong',
          confirmButtonText: 'Close',
        });
      });
  };

  const [revoked, setRevoked] = useState({});

  const handleRevoke = (
    buyerId,
    propertyId,
    index,
    buyerName,
    buyerSurName
  ) => {
    const data = {
      buyerId: buyerId,
      propertyId: propertyId,
    };

    postApiCall(SOLICITOR_REVOKE, data)
      .then((response) => {
        const { status, message, heading } = response?.data;

        if (status === 1) {
          Swal.fire({
            icon: 'success',
            title: heading,
            text: message,
          });

          const uniqueKey = `${buyerId}-${propertyId}`;
          setRevoked((prev) => ({ ...prev, [uniqueKey]: true }));

          Getuserlist();
          Getrequestuserlist();
          Getcancelleduserlist();
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: message,
            confirmButtonText: 'Close',
          });
        }
      })
      .catch((err) => {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Something went wrong',
          confirmButtonText: 'Close',
        });
      });
  };

  const Openmessage = (binderIds) => {
    if (LOGGED_FROM == 'Mobile') {
      window.open(
        `com.comm-app://LoginPage?mailid=${USER_MAIL_ID}&binder=${binderIds}`,
        '_blank'
      );
    } else {
      window.scrollTo(0, 0);
      setMessage(true);
      setChangestab(true);
      setShowMessage(true);
      setMessagedata({ binderId: binderIds });
    }
  };

  const getColor = (status) => {
    if (status === 'E-sign Requested') {
      return 'grey';
    }
    if (status === 'E-sign Registered Successfully') {
      return '#10D35E';
    }
    if (status === 'E-sign Completed') {
      return '#10D35E';
    }
    if (status === 'Pending for E-sign') {
      return 'orange';
    }
    if (status === 'Pending Buyer Signature') {
      return 'orange';
    }
    if (status === 'Pending') {
      return '#F39800';
    }
    if (status === 'Reviewed') {
      return '#08A742';
    }
    if (status === 'Completed') {
      return '#08A742';
    }
    if (status === 'Approved') {
      return '#34b7eb';
    }
    if (status === 'Action required') {
      return '#F93939';
    }
    if (status === 'In Progress') {
      return 'orange';
    }
    if (status === 'Forwarded') {
      return '#10D35E';
    } else {
      return 'grey';
    }
  };

  const directcommBinder = (binderId) => {
    setCurrentBinder(binderId);
    setModalIsOpen(true);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getApiCall(SOLICITOR_REAL_TIME + `/0`);
        if (res?.data?.solicitorRealTime == 1) {
          setRealTimeLog((prevRealTimeLog) => !prevRealTimeLog);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
    const intervalId = setInterval(fetchData, 5000);
    return () => clearInterval(intervalId);
  }, []);

  const [confirmLoading, setConfirmLoading] = useState(false);

  const hasLoadedOnceRef = useRef(false);
  const hasHandledRealtimeRef = useRef(false);

  useEffect(() => {
    if (!hasLoadedOnceRef.current && !confirmLoading) {
      hasLoadedOnceRef.current = true;

      Getuserlist();
      Getrequestuserlist();
      Getcancelleduserlist();
    }

    if (realTimeLog && !confirmLoading && !hasHandledRealtimeRef.current) {
      hasHandledRealtimeRef.current = true;

      Getuserlist();
      Getrequestuserlist();
      Getcancelleduserlist();
    }

    if (!realTimeLog) {
      hasHandledRealtimeRef.current = false;
    }
  }, [realTimeLog, confirmLoading]);

  const Contact = ({
    row,
    directcomm,
    moxouserId,
    solicitor,
    requestedSolicitor,
    requestedBuyerSolicitor,
  }) => {
    const [isDialogOpen, setDialogOpen] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
      setDialogOpen(true);
    };

    const [requestBinderPopup, setRequestBinderPopup] = useState(false);
    const [requestBuyerBinderPopup, setRequestBuyerBinderPopup] =
      useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingRequest, setLoadingRequest] = useState(false);
    const handleRequestBinderDialogCancel = () => {
      setRequestBinderPopup(false);
    };

    const handleRequestedBinder = () => {
      setLoading(true);

      const data = {
        solicitorId: userDetail?.userId,
        userId: row?.buyerId,
      };

      postApiCall(SOLICITOR_CREATE_SOL_BUYER_BINDER, data)
        .then((response) => {
          directcomm(response?.binderId);
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          setLoading(false);
          setRequestBinderPopup(false);
        });
    };

    const handleRequestBuyerBinderDialogCancel = () => {
      setRequestBuyerBinderPopup(false);
    };

    const handleRequestedBuyerBinder = () => {
      setLoadingRequest(true);

      const data = {
        userId: row?.buyerId,
      };

      postApiCall(SOLICITOR_CREATE_BINDER_BEFORE_ACCEPT, data).then((res) => {
        directcomm(res?.data?.binderId);
        setLoadingRequest(false);
        setRequestBuyerBinderPopup(false);
        Getrequestuserlist();
      });
    };

    useEffect(() => {
      if (loading || loadingRequest) {
        document.body.style.pointerEvents = 'none';
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.pointerEvents = 'auto';
        document.body.style.overflow = 'auto';
      }

      return () => {
        document.body.style.pointerEvents = 'auto';
        document.body.style.overflow = 'auto';
      };
    }, [loading, loadingRequest]);

    return (
      <>
        <Stack direction={'row'}>
          <Avatar
            style={{
              position: 'relative',
              border: '1px solid rgba(0, 0, 0, 0.12)',
              background: 'white',
              marginRight: '5px',
              height: '30px',
              width: '30px',
              cursor: 'pointer',
              borderRadius: '5px',
            }}
            onClick={() => {
              if (!moxouserId) {
                directcomm(row?.user?.userId);
              } else if (requestedSolicitor) {
                if (row?.binderId != 'null') {
                  directcomm(row?.binderId);
                } else {
                  setRequestBinderPopup(true);
                }
              } else if (requestedBuyerSolicitor) {
                if (row?.binderId != null) {
                  directcomm(row?.binderId);
                } else {
                  setRequestBuyerBinderPopup(true);
                }
              } else if (solicitor) {
                directcomm(row?.binderId);
              } else {
                {
                  directcomm(row);
                }
              }
            }}
          >
            <Messageicon
              height={16}
              width={16}
              style={{ top: '50%', left: '50%' }}
            />
          </Avatar>
          <Avatar
            style={{
              position: 'relative',
              border: '1px solid rgba(0, 0, 0, 0.12)',
              background: 'white',
              cursor: 'pointer',
              height: '30px',
              width: '30px',
              marginLeft: '5px',
              borderRadius: '5px',
            }}
            onMouseEnter={() => {
              setIsHovered(true);
            }}
            onMouseLeave={() => {
              setIsHovered(false);
            }}
            onClick={() => {
              //   window.scrollTo(0, 0);
              //   if (solicitor) {
              //     setMessage(true);
              //     setChangestab(true);
              //     localStorage.setItem('dialId', row?.userEmail);
              //     setShowMessage(true);
              //     setMessagedata({ incomingcall: true });
              //   } else if (requestedSolicitor) {
              //     setMessage(true);
              //     setChangestab(true);
              //     localStorage.setItem('dialId', row?.buyerEmail);
              //     setShowMessage(true);
              //     setMessagedata({ incomingcall: true });
              //   } else if (requestedBuyerSolicitor) {
              //     setMessage(true);
              //     setChangestab(true);
              //     localStorage.setItem('dialId', row?.buyerEmail);
              //     setShowMessage(true);
              //     setMessagedata({ incomingcall: true });
              //   } else {
              //     setMessage(true);
              //     setChangestab(true);
              //     localStorage.setItem('dialId', row?.userEmail);
              //     setShowMessage(true);
              //     setMessagedata({ incomingcall: true });
              // }

              return window.open(`tel:` + row?.buyerMobile);
            }}
          >
            <Call height={16} width={16} style={{ top: '50%', left: '50%' }} />
          </Avatar>
          {/* &nbsp;&nbsp;
          <Grid
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              marginTop: '3px',
              cursor: 'pointer',
            }}
            onClick={handleClick}
          >
            {isHovered && <Calldownarrow />}
          </Grid>
          <ContactPopOver
            name={row?.buyerName}
            surname={row?.buyerSurName}
            emailid={row?.userEmail}
            mobilenum={row?.buyerMobile}
            isDialogOpen={isDialogOpen}
            setDialogOpen={setDialogOpen}
            anchorEl={anchorEl}
            setAnchorEl={setAnchorEl}
            solicitor={true}
            setMessage={setMessage}
            setChangestab={setChangestab}
          /> */}
        </Stack>
        <Dialog
          open={requestBinderPopup}
          onClose={handleRequestBinderDialogCancel}
          hideBackdrop
          PaperProps={{
            sx: {
              position: 'absolute',
              borderRadius: '8px',
              background: '#FFFFFF',
              border: '0.5px solid #D9D9D9',
              padding: '30px',
              boxShadow: 'none',
            },
          }}
        >
          <Grid container direction="column" sx={{ gap: '20px' }}>
            <Grid item container sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography
                sx={{
                  fontFamily: 'Poppins !important',
                  fontStyle: 'normal !important',
                  fontWeight: '500 !important',
                  fontSize: matchessm ? '16px' : '24px',
                  lineHeight: '36px',
                  color: '#000000',
                }}
              >
                Binder not available
              </Typography>
            </Grid>
            <Grid>
              <Typography
                sx={{
                  fontFamily: 'Poppins !important',
                  fontStyle: 'normal !important',
                  fontWeight: '400 !important',
                  fontSize: matchessm ? '12px' : '16px',
                  color: '#666666',
                }}
              >
                Do you want to create a binder with {row?.buyerName}{' '}
                {row?.buyerSurName}?
              </Typography>
            </Grid>
            <Grid container direction="row" justifyContent="flex-end" gap={2}>
              <Button
                variant="outlined"
                style={{
                  padding: matchessm ? '7px 20px' : '10px 39px',
                  height: '41px',
                  fontSize: '14px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'none',
                }}
                disabled={loading}
                onClick={handleRequestBinderDialogCancel}
              >
                Cancel
              </Button>
              <Button
                variant="outlined"
                style={{
                  padding: matchessm ? '7px 20px' : '10px 39px',
                  height: '41px',
                  fontSize: '14px',
                  color: '#FFFFFF',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  background: '#4ca4d6',
                  borderRadius: '5px',
                  textTransform: 'none',
                }}
                disabled={loading}
                onClick={() => handleRequestedBinder()}
              >
                Confirm
              </Button>
              {loading && (
                <img
                  alt="Logo"
                  src={Loading}
                  className="loaderImage"
                  style={{
                    height: '40px',
                    width: '40px',
                  }}
                />
              )}
            </Grid>
          </Grid>
        </Dialog>
        <Dialog
          open={requestBuyerBinderPopup}
          onClose={handleRequestBinderDialogCancel}
          hideBackdrop
          PaperProps={{
            sx: {
              position: 'absolute',
              borderRadius: '8px',
              background: '#FFFFFF',
              border: '0.5px solid #D9D9D9',
              padding: '30px',
              boxShadow: 'none',
            },
          }}
        >
          <Grid container direction="column" sx={{ gap: '20px' }}>
            <Grid item container sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography
                sx={{
                  fontFamily: 'Poppins !important',
                  fontStyle: 'normal !important',
                  fontWeight: '500 !important',
                  fontSize: matchessm ? '16px' : '24px',
                  lineHeight: '36px',
                  color: '#000000',
                }}
              >
                Binder not available
              </Typography>
            </Grid>
            <Grid>
              <Typography
                sx={{
                  fontFamily: 'Poppins !important',
                  fontStyle: 'normal !important',
                  fontWeight: '400 !important',
                  fontSize: matchessm ? '12px' : '16px',
                  color: '#666666',
                }}
              >
                Do you want to create a binder with {row?.buyerName}{' '}
                {row?.buyerSurName}?
              </Typography>
            </Grid>
            <Grid container direction="row" justifyContent="flex-end" gap={2}>
              <Button
                variant="outlined"
                style={{
                  padding: matchessm ? '7px 20px' : '10px 39px',
                  height: '41px',
                  fontSize: '14px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'none',
                }}
                disabled={loading}
                onClick={handleRequestBuyerBinderDialogCancel}
              >
                Cancel
              </Button>
              <Button
                variant="outlined"
                style={{
                  padding: matchessm ? '7px 20px' : '10px 39px',
                  height: '41px',
                  fontSize: '14px',
                  color: '#FFFFFF',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  background: '#4ca4d6',
                  borderRadius: '5px',
                  textTransform: 'none',
                }}
                disabled={loading}
                onClick={() => handleRequestedBuyerBinder()}
              >
                Confirm
              </Button>
              {loadingRequest && (
                <img
                  alt="Logo"
                  src={Loading}
                  className="loaderImage"
                  style={{
                    height: '40px',
                    width: '40px',
                  }}
                />
              )}
            </Grid>
          </Grid>
        </Dialog>
      </>
    );
  };

  const currentPage = window.location.pathname;
  const [callwaiting, setCallwaiting] = useState();

  return (
    <>
      <datacontextsoli.Provider
        value={{
          callwaiting,
          setCallwaiting,
          setShowMessage,
          setMessagedata,
          realTimeLog,
          handleOpenHelpCenter,
        }}
      >
        <AppHeader
          message={message}
          setMessage={setMessage}
          solicitor={true}
          setBinderId={setBinderId}
          binderId={binderId}
          changestab={changestab}
          setDashormes={setDashormes}
          dashormes={dashormes}
          setChangestab={setChangestab}
          setOpenprofile={setOpenprofile}
          openhelp={openhelp}
          setOpenhelp={setOpenhelp}
          setIsOpenFileManager={setIsOpenFileManager}
        />
        {openprofile ? (
          <ProfileSettings solicitor={true} setOpenprofile={setOpenprofile} />
        ) : openhelp ? (
          <HelpCenterHome onBack={handleHelpCenterBack} />
        ) : (
          <>
            {isOpenFileManager ? (
              <DocumentHub
                isFromBuyerSolicitor={isFromBuyerSolicitor}
                isFromVendorSolicitor={isFromVendorSolicitor}
                setIsOpenFileManager={setIsOpenFileManager}
                propertyAddress={selectedPropertyAddress?.propertyAddress}
                propertyId={selectedPropertyAddress?.propertyId}
                buyerId={
                  isFromVendorSolicitor
                    ? selectedPropertyAddress?.vendorId
                    : selectedPropertyAddress?.buyerId
                }
                isFileView={isFileView}
                userType={
                  isFromBuyerSolicitor
                    ? 'Buyer Solicitor'
                    : isFromVendorSolicitor
                    ? 'Vendor Solicitor'
                    : ''
                }
                getListInfo={recallAllUserLists}
                statustext={statustextpopup}
              />
            ) : (
              <Grid sx={{ height: '100%', overflowY: 'auto' }}>
                <div id="moxo-roots" style={{ display: 'none' }}></div>

                <Grid
                  sx={{ margin: matchessm ? '15px 10px 50px 10px' : '50px' }}
                  display={'flex'}
                  flexDirection={'column'}
                >
                  <Typography
                    sx={{
                      fontFamily: 'poppins',
                      fontSize: matchessm
                        ? '16px'
                        : matchesmd
                        ? '22px'
                        : '32px',
                      fontWeight: 600,
                    }}
                  >
                    {userDetail?.isFirstLogin == 0 ? 'Welcome Back' : 'Welcome'}
                    , {name} {surname} 👋
                  </Typography>
                  <Typography
                    sx={{
                      fontFamily: 'poppins',
                      fontSize: matchessm ? '12px' : matchesmd ? '16' : '20px',
                      margin: matchesmd ? '10px 10px' : '30px 0 0 50px',
                      color: '#666666',
                      maxWidth: '1120px',
                    }}
                  >
                    retreX is a powerful property exchange that offers both
                    buyers and sellers access to trustworthy insights and tools
                    to trade safely and securely.
                  </Typography>
                </Grid>
                <Card
                  ref={cardScrollRef}
                  sx={{
                    margin: matchessm ? '15px 10px 50px 10px' : '50px',
                    padding: '20px',
                    height: '100%',
                    overflowY: 'auto',
                  }}
                >
                  {/* <div className='scrollsolicitor'> */}

                  <Grid
                    container
                    sx={{
                      display: 'flex',
                      alighItems: 'center',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Grid
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '20px',
                      }}
                    >
                      <PublishedIcon />
                      <Typography
                        sx={{
                          fontFamily: 'poppins',
                          fontSize: matchessm ? '18px' : '24px',
                          fontWeight: 500,
                        }}
                      >
                        Clients Register
                      </Typography>
                    </Grid>
                  </Grid>

                  <Grid>
                    <Grid sx={{ marginTop: '70px' }}>
                      <Typography
                        sx={{
                          ...poppins400,
                          fontSize: '14px',
                          fontWeight: 400,
                          color: '#000000',
                        }}
                      >
                        Requested{' '}
                        {Array.isArray(requestedList) &&
                          requestedList.length > 0 &&
                          ` (${requestedList.length})`}
                      </Typography>
                    </Grid>
                    <Grid
                      sx={{
                        margin: 'auto',
                        borderRadius: '5px',
                        marginTop: '20px',
                      }}
                    >
                      <TableContainer
                        style={{
                          border: '1px solid #D9D9D9',
                          borderRadius: '5px',
                        }}
                      >
                        <Table
                          sx={{
                            '& tbody tr:hover': {
                              backgroundColor: 'transparent',
                            },
                          }}
                          aria-labelledby="tableTitle"
                          size="medium"
                        >
                          <TableHead>
                            <TableRow>
                              <TableCell sx={{ width: '20px' }}>
                                <input color="primary" type="checkbox" />
                              </TableCell>
                              {headCells?.map((headCell) => (
                                <TableCell
                                  align="left"
                                  sx={{
                                    ...poppins400,
                                    ...fontsize10,
                                    color: '#666666',
                                    whiteSpace: 'nowrap',
                                    width: '250px',
                                  }}
                                >
                                  <TableSortLabel>
                                    {headCell.label}
                                    <Box
                                      component="span"
                                      sx={visuallyHidden}
                                    ></Box>
                                  </TableSortLabel>
                                </TableCell>
                              ))}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {loadingRequests ? (
                              <TableRow>
                                <TableCell colSpan={7} align="center">
                                  <Grid
                                    sx={{
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      flexDirection: 'column',
                                    }}
                                  >
                                    <img
                                      src={Loading}
                                      alt="loading"
                                      style={{
                                        height: 80,
                                        width: 80,
                                        animation: 'spin 2s linear infinite',
                                      }}
                                    />
                                  </Grid>
                                </TableCell>
                              </TableRow>
                            ) : Array.isArray(requestedList) &&
                              requestedList.length > 0 ? (
                              requestedList.map((row, index) => {
                                return (
                                  <TableRow
                                    hover
                                    role="checkbox"
                                    tabIndex={-1}
                                    key={index}
                                  >
                                    <TableCell>
                                      <Typography
                                        style={{ paddingLeft: '13.88px' }}
                                      >
                                        <FormControlLabel
                                          className="checkbox"
                                          control={
                                            <input
                                              color="primary"
                                              type="checkbox"
                                            />
                                          }
                                        />
                                      </Typography>
                                      <Typography sx={checkbox_style} />
                                    </TableCell>

                                    <TableCell
                                      sx={{ padding: '20px 0', width: '200px' }}
                                    >
                                      <Typography
                                        sx={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          gap: '10px',
                                        }}
                                      >
                                        <Box
                                          sx={{
                                            position: 'relative',
                                            display: 'inline-flex',
                                          }}
                                        >
                                          {row?.profileImage == '' ||
                                          row?.profileImage == null ? (
                                            <Avatar
                                              style={{
                                                width: '36px',
                                                height: '37px',
                                                fontFamily: 'poppins',
                                                backgroundColor: '#666666',
                                              }}
                                            >
                                              {row?.buyerName
                                                ?.charAt(0)
                                                ?.toUpperCase() +
                                                row?.buyerSurName
                                                  ?.charAt(0)
                                                  ?.toUpperCase()}
                                            </Avatar>
                                          ) : (
                                            <Avatar
                                              alt={
                                                row?.buyerName?.charAt(0) +
                                                row?.buyerSurName?.charAt(0)
                                              }
                                              src={row?.profileImage}
                                              style={{
                                                width: '36px',
                                                height: '37px',
                                              }}
                                            />
                                          )}
                                        </Box>
                                        <Box sx={{ position: 'relative' }}>
                                          <Typography sx={imageCont}>
                                            <Typography
                                              sx={{
                                                fontSize: '12px',
                                                fontFamily: 'Poppins',
                                                fontWeight: '400',
                                                cursor: 'pointer',
                                              }}
                                            >
                                              <Typography
                                                sx={{
                                                  fontSize: '12px',
                                                  fontFamily: 'Poppins',
                                                  fontWeight: '400',
                                                  whiteSpace: 'nowrap',
                                                }}
                                              >
                                                {row?.buyerName +
                                                  ' ' +
                                                  row?.buyerSurName}
                                              </Typography>
                                            </Typography>
                                            &nbsp;
                                          </Typography>
                                          <Stack
                                            direction={'row'}
                                            spacing={0.5}
                                            justifyContent={'start'}
                                            alignItems={'center'}
                                            sx={{ position: 'absolute' }}
                                          >
                                            <Avatar
                                              alt=""
                                              src={BlueTick}
                                              size={'small'}
                                              sx={{
                                                height: '10px',
                                                width: '10px',
                                              }}
                                            />
                                            <Avatar
                                              alt=""
                                              size={'small'}
                                              src={Monetize}
                                              sx={{
                                                height: '10px',
                                                width: '10px',
                                              }}
                                            />
                                          </Stack>
                                        </Box>
                                      </Typography>
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      sx={{ width: '150px' }}
                                    >
                                      <Contact
                                        row={row}
                                        directcomm={directcommBinder}
                                        moxouserId={true}
                                        requestedBuyerSolicitor={true}
                                      />
                                    </TableCell>
                                    <TableCell sx={{ padding: '20px 0' }}>
                                      <Typography
                                        sx={{
                                          fontFamily: 'poppins',
                                          whiteSpace: 'nowrap',
                                        }}
                                      >
                                        -
                                      </Typography>
                                    </TableCell>
                                    <TableCell sx={{ padding: '20px 0' }}>
                                      <Typography
                                        sx={{
                                          fontFamily: 'poppins',
                                          whiteSpace: 'nowrap',
                                        }}
                                      >
                                        -
                                      </Typography>
                                    </TableCell>
                                    <TableCell sx={{ padding: '20px 0' }}>
                                      <Typography
                                        sx={{
                                          fontFamily: 'poppins',
                                          whiteSpace: 'nowrap',
                                        }}
                                      >
                                        -
                                      </Typography>
                                    </TableCell>
                                    <TableCell
                                      sx={{
                                        width: '350px',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '10px',
                                      }}
                                    >
                                      <Box
                                        sx={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                          gap: '10px',
                                        }}
                                      >
                                        <Button
                                          sx={{
                                            fontFamily: 'poppins',
                                            fontSize: '12px',
                                            fontWeight: 400,
                                            border:
                                              '1px solid rgba(17, 35, 71, 0.1)',
                                            padding: '5px 15px',
                                            color: '#666666',
                                            whiteSpace: 'nowrap',
                                            borderRadius: '5px',
                                            textTransform: 'none',
                                            '&:hover': {
                                              color: '#666666',
                                            },
                                          }}
                                          onClick={() =>
                                            handleDecline(
                                              row?.buyerId,
                                              row?.buyerName,
                                              row?.buyerSurName
                                            )
                                          }
                                        >
                                          Decline &nbsp;
                                        </Button>
                                        <Button
                                          sx={{
                                            fontFamily: 'poppins',
                                            fontSize: '12px',
                                            fontWeight: 400,
                                            border: '1px solid #4CA4D6',
                                            padding: '5px 15px',
                                            color: '#FFFFFF',
                                            whiteSpace: 'nowrap',
                                            backgroundColor: '#4CA4D6',
                                            borderRadius: '5px',
                                            textTransform: 'none',
                                            '&:hover': {
                                              backgroundColor: '#4CA4D6',
                                              color: '#FFFFFF',
                                            },
                                          }}
                                          onClick={() =>
                                            handleAccept(
                                              row?.buyerId,
                                              solicitorId,
                                              row?.buyerName,
                                              row?.buyerSurName
                                            )
                                          }
                                        >
                                          Accept &nbsp;
                                        </Button>
                                      </Box>
                                      <Box
                                        sx={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          justifyContent: 'center',
                                        }}
                                      >
                                        <Typography
                                          sx={{
                                            ...poppins400,
                                            fontSize: '12px',
                                            color: '#D9D9D9',
                                          }}
                                        >
                                          Requested:{' '}
                                          {dayjs(row?.linkedAt).format(
                                            'h:mma DD MMM YYYY'
                                          )}
                                        </Typography>
                                      </Box>
                                    </TableCell>
                                  </TableRow>
                                );
                              })
                            ) : (
                              <TableRow>
                                <TableCell colSpan={7} align="center">
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins',
                                      fontSize: '14px',
                                      color: '#999999',
                                    }}
                                  >
                                    No requests!
                                  </Typography>
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Grid>
                  </Grid>

                  {/* </div> */}
                  <Grid>
                    <Grid sx={{ marginTop: '70px' }}>
                      <Typography
                        sx={{
                          ...poppins400,
                          fontSize: '14px',
                          fontWeight: 400,
                          color: '#000000',
                        }}
                      >
                        Clients{' '}
                        {buyerActiveList?.length + buyerInactiveList?.length >
                          0 &&
                          `(${
                            buyerActiveList?.length + buyerInactiveList?.length
                          })`}
                      </Typography>
                    </Grid>
                    <Grid
                      sx={{
                        margin: 'auto',
                        borderRadius: '5px',
                        marginTop: '20px',
                      }}
                    >
                      <TableContainer
                        style={{
                          border: '1px solid #D9D9D9',
                          borderRadius: '5px',
                        }}
                      >
                        <Table
                          sx={{
                            '& tbody tr:hover': {
                              backgroundColor: 'transparent',
                            },
                          }}
                          aria-labelledby="tableTitle"
                          size="medium"
                        >
                          <TableHead>
                            <TableRow>
                              <TableCell sx={{ width: '20px' }}>
                                <input color="primary" type="checkbox" />
                              </TableCell>
                              {headCells?.map((headCell) => (
                                <TableCell
                                  align="left"
                                  sx={{
                                    ...poppins400,
                                    ...fontsize10,
                                    color: '#666666',
                                    whiteSpace: 'nowrap',
                                    width: '250px',
                                  }}
                                >
                                  <TableSortLabel>
                                    {headCell.label}
                                    <Box
                                      component="span"
                                      sx={visuallyHidden}
                                    ></Box>
                                  </TableSortLabel>
                                </TableCell>
                              ))}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            <>
                              <TableRow>
                                <TableCell
                                  colSpan={7}
                                  sx={{
                                    paddingLeft: '13.88px',
                                    borderBottom: 'none',
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      ...poppins400,
                                      fontSize: '14px',
                                      fontWeight: 400,
                                      color: '#000000',
                                    }}
                                  >
                                    Active{' '}
                                    {Array.isArray(buyerActiveList) &&
                                      buyerActiveList.length > 0 &&
                                      ` (${buyerActiveList?.length})`}
                                  </Typography>
                                </TableCell>
                              </TableRow>
                              {loadingUsers ? (
                                <TableRow>
                                  <TableCell colSpan={7} align="center">
                                    <Grid
                                      sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        flexDirection: 'column',
                                      }}
                                    >
                                      <img
                                        src={Loading}
                                        alt="loading"
                                        style={{
                                          height: 80,
                                          width: 80,
                                          animation: 'spin 2s linear infinite',
                                        }}
                                      />
                                    </Grid>
                                  </TableCell>
                                </TableRow>
                              ) : Array.isArray(buyerActiveList) &&
                                buyerActiveList?.length > 0 ? (
                                buyerActiveList?.map((row) => {
                                  return (
                                    <React.Fragment key={row?.buyerId}>
                                      <TableRow
                                        hover
                                        role="checkbox"
                                        tabIndex={-1}
                                        key={row?.buyerId}
                                      >
                                        <TableCell>
                                          <Typography
                                            style={{ paddingLeft: '13.88px' }}
                                          >
                                            <FormControlLabel
                                              className="checkbox"
                                              control={
                                                <input
                                                  color="primary"
                                                  type="checkbox"
                                                />
                                              }
                                            />
                                          </Typography>
                                          <Typography sx={checkbox_style} />
                                        </TableCell>

                                        <TableCell
                                          sx={{
                                            padding: '20px 0',
                                            width: '200px',
                                          }}
                                        >
                                          <Typography
                                            sx={{
                                              display: 'flex',
                                              alignItems: 'center',
                                              gap: '10px',
                                            }}
                                          >
                                            <Box
                                              sx={{
                                                position: 'relative',
                                                display: 'inline-flex',
                                              }}
                                            >
                                              {row?.profileImage == '' ||
                                              row?.profileImage == null ? (
                                                <Avatar
                                                  style={{
                                                    width: '36px',
                                                    height: '37px',
                                                    fontFamily: 'poppins',
                                                    backgroundColor: '#666666',
                                                  }}
                                                >
                                                  {row?.buyerName
                                                    ?.charAt(0)
                                                    ?.toUpperCase() +
                                                    row?.buyerSurName
                                                      ?.charAt(0)
                                                      ?.toUpperCase()}
                                                </Avatar>
                                              ) : (
                                                <Avatar
                                                  alt={
                                                    row?.buyerName?.charAt(0) +
                                                    row?.buyerSurName?.charAt(0)
                                                  }
                                                  src={row?.profileImage}
                                                  style={{
                                                    width: '36px',
                                                    height: '37px',
                                                  }}
                                                />
                                              )}
                                            </Box>
                                            <Box sx={{ position: 'relative' }}>
                                              <Typography sx={imageCont}>
                                                <Typography
                                                  sx={{
                                                    fontSize: '12px',
                                                    fontFamily: 'Poppins',
                                                    fontWeight: '400',
                                                    cursor: 'pointer',
                                                  }}
                                                >
                                                  <Typography
                                                    sx={{
                                                      fontSize: '12px',
                                                      fontFamily: 'Poppins',
                                                      fontWeight: '400',
                                                      whiteSpace: 'nowrap',
                                                    }}
                                                  >
                                                    {row?.buyerName +
                                                      ' ' +
                                                      row?.buyerSurName}
                                                  </Typography>
                                                </Typography>
                                                {/* &nbsp; */}
                                                {/* <KeyboardArrowDownIcon /> */}
                                              </Typography>
                                              <Stack
                                                direction={'row'}
                                                spacing={0.5}
                                                justifyContent={'start'}
                                                alignItems={'center'}
                                                sx={{ position: 'absolute' }}
                                              >
                                                <Avatar
                                                  alt=""
                                                  src={BlueTick}
                                                  size={'small'}
                                                  sx={{
                                                    height: '10px',
                                                    width: '10px',
                                                  }}
                                                />
                                                <Avatar
                                                  alt=""
                                                  size={'small'}
                                                  src={Monetize}
                                                  sx={{
                                                    height: '10px',
                                                    width: '10px',
                                                  }}
                                                />
                                              </Stack>
                                            </Box>
                                          </Typography>
                                        </TableCell>
                                        <TableCell
                                          align="left"
                                          sx={{ width: '150px' }}
                                        >
                                          <Contact
                                            row={row}
                                            directcomm={directcommBinder}
                                            moxouserId={true}
                                            solicitor={true}
                                          />
                                        </TableCell>
                                        <TableCell
                                          sx={{
                                            padding: '10px 0 0 15px',
                                            width: '200px',
                                          }}
                                        >
                                          <Typography
                                            sx={{
                                              fontFamily: 'poppins',
                                              whiteSpace: 'nowrap',
                                            }}
                                          >
                                            -
                                          </Typography>
                                        </TableCell>
                                        <TableCell
                                          align="left"
                                          sx={{ width: '200px' }}
                                        >
                                          <Typography
                                            sx={{
                                              fontFamily: 'poppins',
                                              whiteSpace: 'nowrap',
                                            }}
                                          >
                                            -
                                          </Typography>
                                        </TableCell>
                                        <TableCell
                                          align="left"
                                          sx={{ width: '200px' }}
                                        >
                                          <Typography
                                            sx={{
                                              fontFamily: 'poppins',
                                              whiteSpace: 'nowrap',
                                            }}
                                          >
                                            -
                                          </Typography>

                                          {/* <Typography
                                sx={{
                                  fontFamily: "poppins",
                                  fontSize: "12px",
                                  fontWeight: 400,
                                  whiteSpace: "nowrap",
                                }}
                              >
                                Keil Adam Glass and Sarah Elizabeth Roseanna
                                Beins
                              </Typography> */}
                                        </TableCell>
                                        <TableCell sx={{ width: '350px' }}>
                                          <Box
                                            sx={{
                                              display: 'flex',
                                              alignItems: 'center',
                                              justifyContent: 'center',
                                              gap: '10px',
                                            }}
                                          >
                                            <Button
                                              sx={{
                                                fontFamily: 'poppins',
                                                fontSize: '12px',
                                                fontWeight: 400,
                                                border: `1px solid ${
                                                  row?.sellingPropertyListDetails &&
                                                  row.sellingPropertyListDetails
                                                    .length > 0
                                                    ? '#6C2AD2'
                                                    : 'grey'
                                                }`,
                                                padding: '5px 15px',
                                                color:
                                                  row?.sellingPropertyListDetails &&
                                                  row.sellingPropertyListDetails
                                                    .length > 0
                                                    ? '#6C2AD2'
                                                    : 'grey',
                                                whiteSpace: 'nowrap',
                                                opacity:
                                                  row
                                                    ?.sellingPropertyListDetails
                                                    ?.length > 0
                                                    ? 1
                                                    : 0.6,
                                                cursor: 'pointer',
                                              }}
                                              onClick={() => {
                                                const key = `active-${row?.buyerId}`;

                                                if (
                                                  openarrow === 'selling' &&
                                                  openarrowindex === key &&
                                                  buyerTable[key]
                                                ) {
                                                  setOpenarrow('');
                                                  setOpenarrowindex(null);
                                                  handleRowClickTwo(
                                                    row?.buyerId,
                                                    'active'
                                                  );
                                                  setSelectedcategorybuying(
                                                    false
                                                  );
                                                } else {
                                                  if (
                                                    openarrowindex &&
                                                    openarrowindex !== key
                                                  ) {
                                                    const [
                                                      prevSection,
                                                      prevId,
                                                    ] =
                                                      openarrowindex.split('-');
                                                    handleRowClickTwo(
                                                      prevId,
                                                      prevSection
                                                    );
                                                  }

                                                  setOpenarrow('selling');
                                                  setOpenarrowindex(key);

                                                  if (!buyerTable[key]) {
                                                    handleRowClickTwo(
                                                      row?.buyerId,
                                                      'active'
                                                    );
                                                  }
                                                  setSelectedcategorybuying(
                                                    false
                                                  );
                                                }
                                              }}
                                            >
                                              Selling &nbsp;
                                              {openarrow == 'selling' &&
                                              openarrowindex ==
                                                `active-${row?.buyerId}` ? (
                                                <KeyboardArrowUpIcon />
                                              ) : (
                                                <KeyboardArrowDownIcon />
                                              )}
                                            </Button>
                                            <Button
                                              sx={{
                                                fontFamily: 'poppins',
                                                fontSize: '12px',
                                                fontWeight: 400,
                                                border: `1px solid ${
                                                  row?.buyingPropertyListDetails &&
                                                  row.buyingPropertyListDetails
                                                    .length > 0
                                                    ? '#4CA4D6'
                                                    : 'grey'
                                                }`,
                                                padding: '5px 15px',
                                                color:
                                                  row?.buyingPropertyListDetails &&
                                                  row.buyingPropertyListDetails
                                                    .length > 0
                                                    ? '#4CA4D6'
                                                    : 'grey',
                                                whiteSpace: 'nowrap',
                                                opacity:
                                                  row?.buyingPropertyListDetails
                                                    ?.length > 0
                                                    ? 1
                                                    : 0.6,
                                                cursor: 'pointer',
                                              }}
                                              onClick={() => {
                                                const key = `active-${row?.buyerId}`;

                                                if (
                                                  openarrow === 'buying' &&
                                                  openarrowindex === key &&
                                                  buyerTable[key]
                                                ) {
                                                  setOpenarrow('');
                                                  setOpenarrowindex(null);
                                                  handleRowClickTwo(
                                                    row?.buyerId,
                                                    'active'
                                                  );
                                                  setSelectedcategorybuying(
                                                    true
                                                  );
                                                } else {
                                                  if (
                                                    openarrowindex &&
                                                    openarrowindex !== key
                                                  ) {
                                                    const [
                                                      prevSection,
                                                      prevId,
                                                    ] =
                                                      openarrowindex.split('-');
                                                    handleRowClickTwo(
                                                      prevId,
                                                      prevSection
                                                    );
                                                  }

                                                  setOpenarrow('buying');
                                                  setOpenarrowindex(key);

                                                  if (!buyerTable[key]) {
                                                    handleRowClickTwo(
                                                      row?.buyerId,
                                                      'active'
                                                    );
                                                  }
                                                  setSelectedcategorybuying(
                                                    true
                                                  );
                                                }
                                              }}
                                            >
                                              Buying &nbsp;
                                              {openarrow == 'buying' &&
                                              openarrowindex ==
                                                `active-${row?.buyerId}` ? (
                                                <KeyboardArrowUpIcon />
                                              ) : (
                                                <KeyboardArrowDownIcon />
                                              )}
                                            </Button>
                                          </Box>
                                        </TableCell>
                                      </TableRow>
                                      <SellerRegisterTable
                                        index={row?.buyerId}
                                        sellerTable={sellerTable}
                                      />
                                      <BuyerRegisterTable
                                        userDetail={userDetail}
                                        setBuyerId={setBuyerId}
                                        setPropertyId={setPropertyId}
                                        setAddress={setAddress}
                                        setUpdatedDate={setUpdatedDate}
                                        setCreatedDate={setCreatedDate}
                                        Sellingfirstcells={Sellingfirstcells}
                                        selectedcategorybuying={
                                          selectedcategorybuying
                                        }
                                        buyerTable={buyerTable}
                                        setBuyerDropdown={setBuyerDropdown}
                                        buyerDropdown={buyerDropdown}
                                        buyingheadCells={buyingheadCells}
                                        getColor={getColor}
                                        updatedDate={updatedDate}
                                        createdDate={createdDate}
                                        buyerId={buyerId}
                                        propertyId={propertyId}
                                        Openmessage={Openmessage}
                                        minDate={minDate}
                                        address={address}
                                        revoked={revoked}
                                        handleRevoke={handleRevoke}
                                        sellingbuyerheadCells={
                                          sellingbuyerheadCells
                                        }
                                        active={true}
                                        index={row?.buyerId}
                                        row={
                                          selectedcategorybuying
                                            ? row?.buyingPropertyListDetails
                                            : row?.sellingPropertyListDetails
                                        }
                                        Getuserlist={Getuserlist}
                                        directcomm={directcommBinder}
                                        setMessage={setMessage}
                                        setMessagedata={setMessagedata}
                                        setShowMessage={setShowMessage}
                                        setChangestab={setChangestab}
                                        confirmLoading={confirmLoading}
                                        setConfirmLoading={setConfirmLoading}
                                        setIsOpenFileManager={
                                          setIsOpenFileManager
                                        }
                                        setSelectedPropertyAddress={
                                          setSelectedPropertyAddress
                                        }
                                        setIsOpenFileManagerDialog={
                                          setIsOpenFileManagerDialog
                                        }
                                        isOpenFileManagerDialog={
                                          isOpenFileManagerDialog
                                        }
                                        isFromBuyerSolicitor={
                                          isFromBuyerSolicitor
                                        }
                                        setIsFromBuyerSolicitor={
                                          setIsFromBuyerSolicitor
                                        }
                                        isFromVendorSolicitor={
                                          isFromVendorSolicitor
                                        }
                                        setIsFromVendorSolicitor={
                                          setIsFromVendorSolicitor
                                        }
                                        isFileView={isFileView}
                                        setIsFileView={setIsFileView}
                                        anchorRef={anchorRef}
                                        setFileManagerBuyerId={
                                          setFileManagerBuyerId
                                        }
                                        setStatustextpopup={setStatustextpopup}
                                        scrollPositionRef={scrollPositionRef}
                                        cardScrollRef={cardScrollRef}
                                      />
                                    </React.Fragment>
                                  );
                                })
                              ) : (
                                <TableRow>
                                  <TableCell colSpan={7} align="center">
                                    <Typography
                                      sx={{
                                        fontFamily: 'Poppins',
                                        fontSize: '14px',
                                        color: '#999',
                                      }}
                                    >
                                      No active clients!
                                    </Typography>
                                  </TableCell>
                                </TableRow>
                              )}
                            </>
                            <>
                              <TableRow>
                                <TableCell
                                  colSpan={7}
                                  sx={{
                                    paddingLeft: '13.88px',
                                    width: 'auto',
                                    borderBottom: 'none',
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      ...poppins400,
                                      fontSize: '14px',
                                      fontWeight: 400,
                                      color: '#000000',
                                    }}
                                  >
                                    Inactive{' '}
                                    {Array.isArray(buyerInactiveList) &&
                                      buyerInactiveList.length > 0 &&
                                      ` (${buyerInactiveList.length})`}
                                  </Typography>
                                </TableCell>
                              </TableRow>
                              {loadingUsers ? (
                                <TableRow>
                                  <TableCell colSpan={7} align="center">
                                    <Grid
                                      sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        flexDirection: 'column',
                                      }}
                                    >
                                      <img
                                        src={Loading}
                                        alt="loading"
                                        style={{
                                          height: 80,
                                          width: 80,
                                          animation: 'spin 2s linear infinite',
                                        }}
                                      />
                                    </Grid>
                                  </TableCell>
                                </TableRow>
                              ) : Array.isArray(buyerInactiveList) &&
                                buyerInactiveList.length > 0 ? (
                                buyerInactiveList.map((row) => {
                                  return (
                                    <React.Fragment key={row?.buyerId}>
                                      <TableRow
                                        hover
                                        role="checkbox"
                                        tabIndex={-1}
                                        key={row?.buyerId}
                                      >
                                        <TableCell>
                                          <Typography
                                            style={{ paddingLeft: '13.88px' }}
                                          >
                                            <FormControlLabel
                                              className="checkbox"
                                              control={
                                                <input
                                                  color="primary"
                                                  type="checkbox"
                                                />
                                              }
                                            />
                                          </Typography>
                                          <Typography sx={checkbox_style} />
                                        </TableCell>

                                        <TableCell
                                          sx={{
                                            padding: '20px 0',
                                            width: '200px',
                                          }}
                                        >
                                          <Typography
                                            sx={{
                                              display: 'flex',
                                              alignItems: 'center',
                                              gap: '10px',
                                            }}
                                          >
                                            <Box
                                              sx={{
                                                position: 'relative',
                                                display: 'inline-flex',
                                              }}
                                            >
                                              {row?.profileImage == null ||
                                              row?.profileImage == '' ? (
                                                <Avatar
                                                  style={{
                                                    width: '36px',
                                                    height: '37px',
                                                    fontFamily: 'poppins',
                                                    backgroundColor: '#666666',
                                                  }}
                                                >
                                                  {row?.buyerName
                                                    ?.charAt(0)
                                                    ?.toUpperCase() +
                                                    row?.buyerSurName
                                                      ?.charAt(0)
                                                      ?.toUpperCase()}
                                                </Avatar>
                                              ) : (
                                                <Avatar
                                                  alt={
                                                    row?.buyerName?.charAt(0) +
                                                    row?.buyerSurName?.charAt(0)
                                                  }
                                                  src={row?.profileImage}
                                                  style={{
                                                    width: '36px',
                                                    height: '37px',
                                                  }}
                                                />
                                              )}
                                            </Box>
                                            <Box sx={{ position: 'relative' }}>
                                              <Typography sx={imageCont}>
                                                <Typography
                                                  sx={{
                                                    fontSize: '12px',
                                                    fontFamily: 'Poppins',
                                                    fontWeight: '400',
                                                    cursor: 'pointer',
                                                  }}
                                                >
                                                  <Typography
                                                    sx={{
                                                      fontSize: '12px',
                                                      fontFamily: 'Poppins',
                                                      fontWeight: '400',
                                                      whiteSpace: 'nowrap',
                                                    }}
                                                  >
                                                    {row?.buyerName +
                                                      ' ' +
                                                      row?.buyerSurName}
                                                  </Typography>
                                                </Typography>
                                                {/* &nbsp;
                                                <KeyboardArrowDownIcon /> */}
                                              </Typography>
                                              <Stack
                                                direction={'row'}
                                                spacing={0.5}
                                                justifyContent={'start'}
                                                alignItems={'center'}
                                                sx={{ position: 'absolute' }}
                                              >
                                                <Avatar
                                                  alt=""
                                                  src={BlueTick}
                                                  size={'small'}
                                                  sx={{
                                                    height: '10px',
                                                    width: '10px',
                                                  }}
                                                />
                                                <Avatar
                                                  alt=""
                                                  size={'small'}
                                                  src={Monetize}
                                                  sx={{
                                                    height: '10px',
                                                    width: '10px',
                                                  }}
                                                />
                                              </Stack>
                                            </Box>
                                          </Typography>
                                        </TableCell>
                                        <TableCell
                                          align="left"
                                          sx={{ width: '150px' }}
                                        >
                                          <Contact
                                            row={row}
                                            directcomm={directcommBinder}
                                            moxouserId={true}
                                            solicitor={true}
                                          />
                                        </TableCell>
                                        <TableCell
                                          sx={{
                                            padding: '10px 0 0 15px',
                                            width: '200px',
                                          }}
                                        >
                                          <Typography
                                            sx={{
                                              fontFamily: 'poppins',
                                              whiteSpace: 'nowrap',
                                            }}
                                          >
                                            -
                                          </Typography>

                                          {/* <Typography
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                }}
                              >
                                <Box
                                  sx={{
                                    position: "relative",
                                    display: "inline-flex",
                                  }}
                                >
                                  <CircularProgress
                                    variant="determinate"
                                    value={100}
                                    sx={{ color: "#C4C4C461" }}
                                    thickness={5}
                                    size={43}
                                  />
                                  <CircularProgress
                                    variant="determinate"
                                    value={60}
                                    sx={{
                                      color: "#10D35E",
                                      position: "absolute",
                                    }}
                                    thickness={5}
                                    size={43}
                                  />
                                  <Typography
                                    variant="caption"
                                    component="div"
                                    sx={{
                                      color: "#000000",
                                      ...poppins500,
                                      fontSize: "14px",
                                      top: "50%",
                                      left: "50%",
                                      transform: "translate(-50%, -50%)",
                                      position: "absolute",
                                    }}
                                  >
                                    <Avatar
                                      alt="Remy"
                                      src={Dp}
                                      style={{
                                        width: "36px",
                                        height: "37px",
                                      }}
                                    />
                                  </Typography>
                                  <Box
                                    sx={{
                                      position: "absolute",
                                      right: "-7px",
                                      top: "-7px",
                                      zIndex: 1,
                                    }}
                                  >
                                    <LinkPartner />
                                  </Box>
                                </Box>
                                <Box sx={{ position: "relative" }}>
                                  <Typography sx={imageCont}>
                                    <Typography
                                      sx={{
                                        fontSize: "12px",
                                        fontFamily: "Poppins",
                                        fontWeight: "400",
                                        cursor: "pointer",
                                      }}
                                    >
                                      <Typography
                                        sx={{
                                          fontSize: "12px",
                                          fontFamily: "Poppins",
                                          fontWeight: "400",
                                          whiteSpace: "nowrap",
                                        }}
                                      >
                                        Sarah Beins
                                      </Typography>
                                    </Typography>
                                  </Typography>
                                  <Stack
                                    direction={"row"}
                                    spacing={0.5}
                                    justifyContent={"start"}
                                    alignItems={"center"}
                                    sx={{ position: "absolute" }}
                                  >
                                    <Avatar
                                      alt=""
                                      src={BlueTick}
                                      size={"small"}
                                      sx={{ height: "10px", width: "10px" }}
                                    />
                                    <Avatar
                                      alt=""
                                      size={"small"}
                                      src={Monetize}
                                      sx={{ height: "10px", width: "10px" }}
                                    />
                                  </Stack>
                                </Box>
                                <Box sx={{ marginLeft: "35px" }}>
                                  <Contact />
                                </Box>
                              </Typography> */}
                                        </TableCell>
                                        <TableCell
                                          align="left"
                                          sx={{ width: '200px' }}
                                        >
                                          <Typography
                                            sx={{
                                              fontFamily: 'poppins',
                                              whiteSpace: 'nowrap',
                                            }}
                                          >
                                            -
                                          </Typography>

                                          {/* <Typography
                                sx={{
                                  fontFamily: "poppins",
                                  fontSize: "12px",
                                  fontWeight: 400,
                                  whiteSpace: "nowrap",
                                }}
                              >
                                177 RainBow Street, Randwick NSW 2031
                              </Typography> */}
                                        </TableCell>
                                        <TableCell
                                          align="left"
                                          sx={{ width: '200px' }}
                                        >
                                          <Typography
                                            sx={{
                                              fontFamily: 'poppins',
                                              whiteSpace: 'nowrap',
                                            }}
                                          >
                                            -
                                          </Typography>

                                          {/* <Typography
                                sx={{
                                  fontFamily: "poppins",
                                  fontSize: "12px",
                                  fontWeight: 400,
                                  whiteSpace: "nowrap",
                                }}
                              >
                                Keil Adam Glass and Sarah Elizabeth Roseanna
                                Beins
                              </Typography> */}
                                        </TableCell>
                                        <TableCell sx={{ width: '350px' }}>
                                          <Box
                                            sx={{
                                              display: 'flex',
                                              alignItems: 'center',
                                              justifyContent: 'center',
                                              gap: '10px',
                                            }}
                                          >
                                            <Button
                                              sx={{
                                                fontFamily: 'poppins',
                                                fontSize: '12px',
                                                fontWeight: 400,
                                                border: `1px solid ${
                                                  row?.sellingPropertyListDetails &&
                                                  row.sellingPropertyListDetails
                                                    .length > 0
                                                    ? '#6C2AD2'
                                                    : 'grey'
                                                }`,
                                                padding: '5px 15px',
                                                color:
                                                  row?.sellingPropertyListDetails &&
                                                  row.sellingPropertyListDetails
                                                    .length > 0
                                                    ? '#6C2AD2'
                                                    : 'grey',
                                                whiteSpace: 'nowrap',
                                                opacity:
                                                  row
                                                    ?.sellingPropertyListDetails
                                                    ?.length > 0
                                                    ? 1
                                                    : 0.6,
                                                cursor: 'pointer',
                                              }}
                                              onClick={() => {
                                                const key = `inactive-${row?.buyerId}`;

                                                if (
                                                  openarrow === 'selling' &&
                                                  openarrowindex === key &&
                                                  buyerTable[key]
                                                ) {
                                                  setOpenarrow('');
                                                  setOpenarrowindex(null);
                                                  handleRowClickTwo(
                                                    row?.buyerId,
                                                    'inactive'
                                                  );
                                                  setSelectedcategorybuying(
                                                    false
                                                  );
                                                } else {
                                                  if (
                                                    openarrowindex &&
                                                    openarrowindex !== key
                                                  ) {
                                                    const [
                                                      prevSection,
                                                      prevId,
                                                    ] =
                                                      openarrowindex.split('-');
                                                    handleRowClickTwo(
                                                      prevId,
                                                      prevSection
                                                    );
                                                  }

                                                  setOpenarrow('selling');
                                                  setOpenarrowindex(key);

                                                  if (!buyerTable[key]) {
                                                    handleRowClickTwo(
                                                      row?.buyerId,
                                                      'inactive'
                                                    );
                                                  }
                                                  setSelectedcategorybuying(
                                                    false
                                                  );
                                                }
                                              }}
                                            >
                                              Selling &nbsp;
                                              {openarrow == 'selling' &&
                                              openarrowindex ==
                                                `inactive-${row?.buyerId}` ? (
                                                <KeyboardArrowUpIcon />
                                              ) : (
                                                <KeyboardArrowDownIcon />
                                              )}
                                            </Button>
                                            <Button
                                              sx={{
                                                fontFamily: 'poppins',
                                                fontSize: '12px',
                                                fontWeight: 400,
                                                border: `1px solid ${
                                                  row?.buyingPropertyListDetails &&
                                                  row.buyingPropertyListDetails
                                                    .length > 0
                                                    ? '#4CA4D6'
                                                    : 'grey'
                                                }`,
                                                padding: '5px 15px',
                                                color:
                                                  row?.buyingPropertyListDetails &&
                                                  row.buyingPropertyListDetails
                                                    .length > 0
                                                    ? '#4CA4D6'
                                                    : 'grey',
                                                whiteSpace: 'nowrap',
                                                opacity:
                                                  row?.buyingPropertyListDetails
                                                    ?.length > 0
                                                    ? 1
                                                    : 0.6,
                                                cursor: 'pointer',
                                              }}
                                              onClick={() => {
                                                const key = `inactive-${row?.buyerId}`;

                                                if (
                                                  openarrow === 'buying' &&
                                                  openarrowindex === key &&
                                                  buyerTable[key]
                                                ) {
                                                  setOpenarrow('');
                                                  setOpenarrowindex(null);
                                                  handleRowClickTwo(
                                                    row?.buyerId,
                                                    'inactive'
                                                  );
                                                  setSelectedcategorybuying(
                                                    true
                                                  );
                                                } else {
                                                  if (
                                                    openarrowindex &&
                                                    openarrowindex !== key
                                                  ) {
                                                    const [
                                                      prevSection,
                                                      prevId,
                                                    ] =
                                                      openarrowindex.split('-');
                                                    handleRowClickTwo(
                                                      prevId,
                                                      prevSection
                                                    );
                                                  }

                                                  setOpenarrow('buying');
                                                  setOpenarrowindex(key);

                                                  if (!buyerTable[key]) {
                                                    handleRowClickTwo(
                                                      row?.buyerId,
                                                      'inactive'
                                                    );
                                                  }
                                                  setSelectedcategorybuying(
                                                    true
                                                  );
                                                }
                                              }}
                                            >
                                              Buying &nbsp;
                                              {openarrow == 'buying' &&
                                              openarrowindex ==
                                                `inactive-${row?.buyerId}` ? (
                                                <KeyboardArrowUpIcon />
                                              ) : (
                                                <KeyboardArrowDownIcon />
                                              )}
                                            </Button>
                                          </Box>
                                        </TableCell>
                                      </TableRow>
                                      <SellerRegisterTable
                                        index={row?.buyerId}
                                        sellerTable={sellerTable}
                                      />
                                      <BuyerRegisterTable
                                        userDetail={userDetail}
                                        setBuyerId={setBuyerId}
                                        setPropertyId={setPropertyId}
                                        setAddress={setAddress}
                                        setUpdatedDate={setUpdatedDate}
                                        setCreatedDate={setCreatedDate}
                                        Sellingfirstcells={Sellingfirstcells}
                                        selectedcategorybuying={
                                          selectedcategorybuying
                                        }
                                        buyerTable={buyerTable}
                                        setBuyerDropdown={setBuyerDropdown}
                                        buyerDropdown={buyerDropdown}
                                        buyingheadCells={buyingheadCells}
                                        getColor={getColor}
                                        updatedDate={updatedDate}
                                        createdDate={createdDate}
                                        buyerId={buyerId}
                                        propertyId={propertyId}
                                        Openmessage={Openmessage}
                                        minDate={minDate}
                                        address={address}
                                        revoked={revoked}
                                        handleRevoke={handleRevoke}
                                        sellingbuyerheadCells={
                                          sellingbuyerheadCells
                                        }
                                        index={row?.buyerId}
                                        row={
                                          selectedcategorybuying
                                            ? row?.buyingPropertyListDetails
                                            : row?.sellingPropertyListDetails
                                        }
                                        Getuserlist={Getuserlist}
                                        directcomm={directcommBinder}
                                        setMessage={setMessage}
                                        setMessagedata={setMessagedata}
                                        setShowMessage={setShowMessage}
                                        setChangestab={setChangestab}
                                        confirmLoading={confirmLoading}
                                        setConfirmLoading={setConfirmLoading}
                                        setIsOpenFileManager={
                                          setIsOpenFileManager
                                        }
                                        setSelectedPropertyAddress={
                                          setSelectedPropertyAddress
                                        }
                                        selectedPropertyAddress={
                                          selectedPropertyAddress
                                        }
                                        setIsOpenFileManagerDialog={
                                          setIsOpenFileManagerDialog
                                        }
                                        isopenfilemanagerdialog={
                                          isOpenFileManagerDialog
                                        }
                                        isFromBuyerSolicitor={
                                          isFromBuyerSolicitor
                                        }
                                        setIsFromBuyerSolicitor={
                                          setIsFromBuyerSolicitor
                                        }
                                        isFromVendorSolicitor={
                                          isFromVendorSolicitor
                                        }
                                        setIsFromVendorSolicitor={
                                          setIsFromVendorSolicitor
                                        }
                                        isfileview={isFileView}
                                        setIsFileView={setIsFileView}
                                        anchorRef={anchorRef}
                                        setFileManagerBuyerId={
                                          setFileManagerBuyerId
                                        }
                                        setStatustextpopup={setStatustextpopup}
                                        scrollPositionRef={scrollPositionRef}
                                        cardScrollRef={cardScrollRef}
                                      />
                                    </React.Fragment>
                                  );
                                })
                              ) : (
                                <TableRow>
                                  <TableCell colSpan={7} align="center">
                                    <Typography
                                      sx={{
                                        fontFamily: 'Poppins',
                                        fontSize: '14px',
                                        color: '#999',
                                      }}
                                    >
                                      No inactive clients!
                                    </Typography>
                                  </TableCell>
                                </TableRow>
                              )}
                            </>
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Grid>
                  </Grid>

                  <Grid sx={{ paddingBottom: '100px' }}>
                    <Grid sx={{ marginTop: '70px' }}>
                      <Typography
                        sx={{
                          ...poppins400,
                          fontSize: '14px',
                          fontWeight: 400,
                          color: '#000000',
                        }}
                      >
                        Cancelled{' '}
                        {Array.isArray(cancelledList) &&
                          cancelledList.length > 0 &&
                          ` (${cancelledList.length})`}
                      </Typography>
                    </Grid>
                    <Grid
                      sx={{
                        margin: 'auto',
                        borderRadius: '5px',
                        marginTop: '20px',
                      }}
                    >
                      <TableContainer
                        style={{
                          border: '1px solid #D9D9D9',
                          borderRadius: '5px',
                        }}
                      >
                        <Table
                          sx={{
                            '& tbody tr:hover': {
                              backgroundColor: 'transparent',
                            },
                          }}
                          aria-labelledby="tableTitle"
                          size="medium"
                        >
                          <TableHead>
                            <TableRow>
                              <TableCell sx={{ width: '20px' }}>
                                <input color="primary" type="checkbox" />
                              </TableCell>
                              {headCells?.map((headCell) => (
                                <TableCell
                                  align="left"
                                  sx={{
                                    ...poppins400,
                                    ...fontsize10,
                                    color: '#666666',
                                    whiteSpace: 'nowrap',
                                    width: '250px',
                                  }}
                                >
                                  <TableSortLabel>
                                    {headCell.label}
                                    <Box
                                      component="span"
                                      sx={visuallyHidden}
                                    ></Box>
                                  </TableSortLabel>
                                </TableCell>
                              ))}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {loadingCancelled ? (
                              <TableRow>
                                <TableCell colSpan={7} align="center">
                                  <Grid
                                    sx={{
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      flexDirection: 'column',
                                    }}
                                  >
                                    <img
                                      src={Loading}
                                      alt="loading"
                                      style={{
                                        height: 80,
                                        width: 80,
                                        animation: 'spin 2s linear infinite',
                                      }}
                                    />
                                  </Grid>
                                </TableCell>
                              </TableRow>
                            ) : Array.isArray(cancelledList) &&
                              cancelledList.length > 0 ? (
                              cancelledList.map((row, index) => {
                                return (
                                  <>
                                    <TableRow
                                      hover
                                      role="checkbox"
                                      tabIndex={-1}
                                      key={index}
                                    >
                                      <TableCell>
                                        <Typography
                                          style={{ paddingLeft: '13.88px' }}
                                        >
                                          <FormControlLabel
                                            className="checkbox"
                                            control={
                                              <input
                                                color="primary"
                                                type="checkbox"
                                              />
                                            }
                                          />
                                        </Typography>
                                        <Typography sx={checkbox_style} />
                                      </TableCell>
                                      <TableCell
                                        sx={{
                                          padding: '20px 0',
                                          width: '200px',
                                        }}
                                      >
                                        <Typography
                                          sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '10px',
                                          }}
                                        >
                                          <Box
                                            sx={{
                                              position: 'relative',
                                              display: 'inline-flex',
                                            }}
                                          >
                                            {row?.profileImage == '' ||
                                            row?.profileImage == null ? (
                                              <Avatar
                                                style={{
                                                  width: '36px',
                                                  height: '37px',
                                                  fontFamily: 'poppins',
                                                  backgroundColor: '#666666',
                                                }}
                                              >
                                                {row?.buyerName
                                                  ?.charAt(0)
                                                  ?.toUpperCase() +
                                                  row?.buyerSurName
                                                    ?.charAt(0)
                                                    ?.toUpperCase()}
                                              </Avatar>
                                            ) : (
                                              <Avatar
                                                alt={
                                                  row?.buyerName?.charAt(0) +
                                                  row?.buyerSurName?.charAt(0)
                                                }
                                                src={row?.profileImage}
                                                style={{
                                                  width: '36px',
                                                  height: '37px',
                                                }}
                                              />
                                            )}
                                          </Box>
                                          <Box sx={{ position: 'relative' }}>
                                            <Typography sx={imageCont}>
                                              <Typography
                                                sx={{
                                                  fontSize: '12px',
                                                  fontFamily: 'Poppins',
                                                  fontWeight: '400',
                                                  cursor: 'pointer',
                                                }}
                                              >
                                                <Typography
                                                  sx={{
                                                    fontSize: '12px',
                                                    fontFamily: 'Poppins',
                                                    fontWeight: '400',
                                                    whiteSpace: 'nowrap',
                                                  }}
                                                >
                                                  {row?.buyerName +
                                                    ' ' +
                                                    row?.buyerSurName}
                                                </Typography>
                                              </Typography>
                                              {/* &nbsp;
                                              <KeyboardArrowDownIcon /> */}
                                            </Typography>
                                            <Stack
                                              direction={'row'}
                                              spacing={0.5}
                                              justifyContent={'start'}
                                              alignItems={'center'}
                                              sx={{ position: 'absolute' }}
                                            >
                                              <Avatar
                                                alt=""
                                                src={BlueTick}
                                                size={'small'}
                                                sx={{
                                                  height: '10px',
                                                  width: '10px',
                                                }}
                                              />
                                              <Avatar
                                                alt=""
                                                size={'small'}
                                                src={Monetize}
                                                sx={{
                                                  height: '10px',
                                                  width: '10px',
                                                }}
                                              />
                                            </Stack>
                                          </Box>
                                        </Typography>
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        sx={{ width: '150px' }}
                                      >
                                        <Contact
                                          row={row}
                                          directcomm={directcommBinder}
                                          moxouserId={true}
                                          requestedSolicitor={true}
                                        />
                                      </TableCell>
                                      <TableCell
                                        sx={{
                                          padding: '10px 0 0 15px',
                                          width: '200px',
                                        }}
                                      >
                                        <Typography
                                          sx={{
                                            fontFamily: 'poppins',
                                            whiteSpace: 'nowrap',
                                          }}
                                        >
                                          -
                                        </Typography>
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        sx={{ width: '200px' }}
                                      >
                                        <Typography
                                          sx={{
                                            fontFamily: 'poppins',
                                            whiteSpace: 'nowrap',
                                          }}
                                        >
                                          -
                                        </Typography>
                                      </TableCell>
                                      <TableCell
                                        align="left"
                                        sx={{ width: '200px' }}
                                      >
                                        <Typography
                                          sx={{
                                            fontFamily: 'poppins',
                                            whiteSpace: 'nowrap',
                                          }}
                                        >
                                          -
                                        </Typography>
                                      </TableCell>
                                      <TableCell
                                        sx={{
                                          width: '350px',
                                          display: 'flex',
                                          flexDirection: 'column',
                                          gap: '10px',
                                        }}
                                      >
                                        <Box
                                          sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: '10px',
                                            '& *': {
                                              cursor: 'default !important',
                                            },
                                          }}
                                        >
                                          <Button
                                            sx={{
                                              fontFamily: 'poppins',
                                              fontSize: '12px',
                                              fontWeight: 400,
                                              border: '1px solid #FF2D55',
                                              padding: '5px 15px',
                                              color: '#FF2D55',
                                              whiteSpace: 'nowrap',
                                              borderRadius: '5px',
                                              textTransform: 'none',
                                            }}
                                          >
                                            Declined &nbsp;
                                          </Button>
                                        </Box>
                                        <Box
                                          sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                          }}
                                        >
                                          <Typography
                                            sx={{
                                              ...poppins400,
                                              fontSize: '12px',
                                              color: '#D9D9D9',
                                            }}
                                          >
                                            Updated:{' '}
                                            {dayjs(row?.linkedAt).format(
                                              'h:mma DD MMM YYYY'
                                            )}
                                          </Typography>
                                        </Box>
                                      </TableCell>
                                    </TableRow>
                                  </>
                                );
                              })
                            ) : (
                              <TableRow>
                                <TableCell colSpan={7} align="center">
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins',
                                      fontSize: '14px',
                                      color: '#A0A0A0',
                                    }}
                                  >
                                    No cancelled lists!
                                  </Typography>
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            )}
            {modalIsOpen && (
              <Moxochat
                open={modalIsOpen}
                onClose={setModalIsOpen}
                binderId={currentBinder}
                isgallery={true}
                issolicitor={true}
                setMessage={setMessage}
                setChangestab={setChangestab}
              />
            )}
            {callwaiting &&
              callwaiting.isMeet == true &&
              !currentPage.includes('/message') && (
                <Moxocall
                  callwaiting={callwaiting}
                  setCallwaiting={setCallwaiting}
                />
              )}
          </>
        )}

        {isOpenFileManagerDialog && (
          <Dialog
            open={isOpenFileManagerDialog}
            onClose={() => setIsOpenFileManagerDialog(false)}
            maxWidth={false}
            fullWidth
            sx={{
              '& .MuiDialog-paper': {
                width: '100%',
                minWidth: !matchessm && '1600px',
                maxWidth: matchessm && '1600px',
              },
            }}
          >
            <DocumentHub
              isFromBuyerSolicitor={isFromBuyerSolicitor}
              isFromVendorSolicitor={isFromVendorSolicitor}
              onBack={() => {
                setIsOpenFileManagerDialog(false);
              }}
              backToContract={() => {
                setIsOpenFileManagerDialog(false);
              }}
              propertyAddress={selectedPropertyAddress?.propertyAddress}
              propertyId={selectedPropertyAddress?.propertyId}
              buyerId={selectedPropertyAddress?.buyerId}
              isDialog={true}
              isDirectBuyerDocumentHistory={true}
              userType={'Vendor Solicitor'}
              getListInfo={recallAllUserLists}
              selectedeta={'Contract Of Sale'}
              statustext={selectedPropertyAddress?.status}
            />
          </Dialog>
        )}
      </datacontextsoli.Provider>

      <datacontextsoli.Provider
        value={{
          callwaiting,
          setCallwaiting,
          setShowMessage,
          messagedata,
          setMessagedata,
        }}
      >
        {!openprofile && showMessage && <Message />}
      </datacontextsoli.Provider>
    </>
  );
};
const Tickicon = () => {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="11.5" cy="11.5" r="9.625" stroke="#10D35E" stroke-width="2" />
      <path
        d="M8.875 11.4561L10.7312 13.3122L14.4435 9.5999"
        stroke="#10D35E"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  );
};
const BuyerRegisterTable = ({
  index,
  row,
  Getuserlist,
  directcomm,
  active,
  userDetail,
  setBuyerId,
  setPropertyId,
  setAddress,
  setUpdatedDate,
  setCreatedDate,
  Sellingfirstcells,
  selectedcategorybuying,
  buyerTable,
  setBuyerDropdown,
  buyerDropdown,
  buyingheadCells,
  getColor,
  updatedDate,
  createdDate,
  buyerId,
  propertyId,
  Openmessage,
  minDate,
  address,
  revoked,
  handleRevoke,
  sellingbuyerheadCells,
  setMessage,
  setShowMessage,
  setMessagedata,
  setChangestab,
  confirmLoading,
  setConfirmLoading,
  setIsOpenFileManager,
  setSelectedPropertyAddress,
  selectedPropertyAddress,
  setIsOpenFileManagerDialog,
  setStatustextpopup,
  isOpenFileManagerDialog,
  isFromBuyerSolicitor,
  isFromVendorSolicitor,
  setIsFromBuyerSolicitor,
  setIsFromVendorSolicitor,
  isFileView,
  setIsFileView,
  setFileManagerBuyerId,
  anchorRef,
  scrollPositionRef,
  cardScrollRef,
}) => {
  const { handleOpenHelpCenter } = React.useContext(datacontextsoli);
  const [showDialog, setShowDialog] = useState(false);
  const [showVendorDialog, setShowVendorDialog] = useState(false);
  const [showSellingDialog, setShowSellingDialog] = useState(false);
  const [showInterestDialog, setShowInterestDialog] = useState(false);
  const [selectedBsDetails, setSelectedBsDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedAgentItemData, setSelectedAgentItemData] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const primaryUserTypeValue = userDetail?.userType;

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches450 = useMediaQuery(theme.breakpoints.down(450));
  const matchesB = useMediaQuery(theme.breakpoints.between(1536, 1636));
  const handleDialogConfirm = (propertyId, agentId, agentEmail) => {
    setLoading(true);

    const data = {
      propertyId,
      solicitorId: userDetail?.userId,
      userId: agentId,
      userEmail: agentEmail,
      isUserAgent: 1,
      solicitorEmail: userDetail?.userEmail,
      isBuying: 1,
    };

    postApiCall(SOLICITOR_CREATE_BINDER, data)
      .then((res) => {
        setShowDialog(false);
        directcomm(res?.data?.binderId);
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  };

  const handleShowDialog = (item) => {
    if (item?.agentDetails?.binderId == null) {
      setSelectedAgentItemData(item);
      setShowDialog(true);
    } else {
      directcomm(item?.agentDetails?.binderId);
    }
  };

  const handleDialogCancel = () => {
    setShowDialog(false);
  };

  const handleSellingDialogConfirm = (propertyId, agentId, agentEmail) => {
    setLoading(true);

    const data = {
      propertyId,
      solicitorId: userDetail?.userId,
      userId: agentId,
      userEmail: agentEmail,
      isUserAgent: 1,
      solicitorEmail: userDetail?.userEmail,
      isBuying: 0,
    };

    postApiCall(SOLICITOR_CREATE_BINDER, data)
      .then((res) => {
        setShowSellingDialog(false);
        directcomm(res?.data?.binderId);
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  };

  const handleSellingDialogCancel = () => {
    setShowSellingDialog(false);
  };

  const handleVendorDialogConfirm = (propertyId, agentId, agentEmail) => {
    setLoading(true);

    const data = {
      propertyId,
      solicitorId: userDetail?.userId,
      userId: agentId,
      userEmail: agentEmail,
      isUserAgent: 0,
      solicitorEmail: userDetail?.userEmail,
      isBuying: 1,
    };

    postApiCall(SOLICITOR_CREATE_BINDER, data)
      .then((res) => {
        setShowVendorDialog(false);
        directcomm(res?.data?.binderId);
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  };
  const handleShowVendorDialog = (item) => {
    setSelectedItem(item);
    setShowVendorDialog(true);
  };

  const handleVendorDialogCancel = () => {
    setShowVendorDialog(false);
  };

  const handleInterestDialogOpen = (bsDetails) => {
    setSelectedBsDetails(bsDetails);
    setShowInterestDialog(true);
  };

  const handleInterestDialogConfirm = (propertyId, bsId, bsEmail) => {
    setLoading(true);

    const data = {
      propertyId,
      solicitorId: userDetail?.userId,
      userId: bsId,
      userEmail: bsEmail,
      isUserAgent: 0,
      solicitorEmail: userDetail?.userEmail,
      isBuying: 0,
    };

    postApiCall(SOLICITOR_CREATE_BINDER, data)
      .then((res) => {
        setShowInterestDialog(false);
        directcomm(res?.data?.binderId);
      })
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  };
  const handleInterestDialogCancel = () => {
    setShowInterestDialog(false);
    setSelectedBsDetails(null);
  };
  const [name, setName] = useState('');
  const [content, setContent] = useState('');

  const [anchorEl, setAnchorEl] = useState(null);
  const handleCloseCheck = () => {
    setAnchorEl(null);
  };

  const openCheck = Boolean(anchorEl);
  const idCheck = openCheck ? 'simple-popover' : undefined;

  const [anchorElPending, setAnchorElPending] = useState(null);
  const [statustext, setStatustext] = useState('');
  const [selectedDate, setSelectedDate] = useState(null);
  const [contarctETADate, setContractETADate] = useState('');
  const [ETAdialogChanged, setETADialogChanged] = useState(false);
  const [selectedeta, setSelectedeta] = useState('');
  const [selectedbuyerdetails, setSelectedbuyerdetails] = useState('');
  const handleDateChange = (newDate) => {
    setETADialogChanged(true);
    if (dayjs.isDayjs(newDate) && newDate.isValid()) {
      const now = dayjs().tz('Australia/Sydney');
      const currentSydneyDate = now.startOf('day');

      if (newDate.isSame(currentSydneyDate, 'day')) {
        const newHour = newDate.hour();

        if (newHour < now.hour() || newHour === now.hour()) {
          newDate = now.add(1, 'hour').set('minute', 0).set('second', 0);
        }
      } else if (newDate.isAfter(currentSydneyDate)) {
        const newHour = newDate.hour();
        const newMinute = newDate.minute();
        const newSecond = newDate.second();
        newDate = newDate.set({
          hour: newHour,
          minute: newMinute,
          second: newSecond,
        });
      } else {
        newDate = now;
        setSelectedDate(newDate);
      }

      setSelectedDate(newDate);
    } else {
    }
  };

  const handleCloseCheckPending = () => {
    let formattedDate = selectedDate.format('YYYY-MM-DD HH:mm:ss');
    let input = {
      propertyId: selectedbuyerdetails?.propertyId,
      buyerId: selectedbuyerdetails?.buyerId,
      ETA: formattedDate,
      checklist: selectedeta,
    };
    postApiCall(STORE_ETA, input).then((res) => {
      setAnchorElPending(null);
      Getuserlist();
    });
  };

  const openCheckPending = Boolean(anchorElPending);
  const idCheckPending = openCheckPending ? 'simple-popover' : undefined;

  const popOverFunc = (event, name, content) => {
    setName(name);
    setContent(content);
    setAnchorEl(event.currentTarget);
  };
  const [popupBinderId, setPopupBinderId] = useState('');
  const [url66W, setUrl66W] = useState(false);
  const pendingStatus = (event, item, texteta) => {
    setAnchorElPending(event.currentTarget);

    if (texteta == 'Contract') {
      setContractETADate(item?.contractETA);
      setCreatedDate(item?.contractCreatedAt);
      setUpdatedDate(item?.contractLastUpdated);
    } else {
      setContractETADate(item?.WETA);
      setCreatedDate(item?.WCreatedAt);
      setUpdatedDate(item?.WLastUpdated);
    }

    if (texteta == 'Contract') {
      if (item?.contractStatus === 'In Progress') {
        setStatustext('Action Required');
        setAddress(item?.propertyAddress);
        setPropertyId(item?.propertyId);
        setBuyerId(item?.buyerId);
      } else {
        setStatustext(item?.contractStatus);
        setAddress(item?.propertyAddress);
        setPropertyId(item?.propertyId);
        setBuyerId(item?.buyerId);
      }
    } else {
      if (item?.WStatus === 'Requested') {
        setStatustext('Action Required');
        setAddress(item?.propertyAddress);
        setPropertyId(item?.propertyId);
        setBuyerId(item?.buyerId);
        setUrl66W(item?.URL66W);
      } else {
        setStatustext(item?.WStatus);
        setAddress(item?.propertyAddress);
        setPropertyId(item?.propertyId);
        setBuyerId(item?.buyerId);
        setUrl66W(item?.URL66W);
      }
    }
    setSelectedeta(texteta);
    setSelectedbuyerdetails(item);
  };

  const Warningfunc = ({ selectedDate }) => {
    let today = new Date();
    dayjs(today).format('YYYY-MM-DD hh:mm');
    const differenceInMillis = Math.abs(new Date(selectedDate) - today);
    const millisecondsPerDay = 1000 * 60 * 60 * 24;
    const differenceInDays = Math.floor(
      differenceInMillis / millisecondsPerDay
    );
    if (differenceInDays < 2) {
      return <Warning />;
    }
  };

  const [isInterestDialogOpen, setInterestDialogOpen] = useState(false);
  const [isInterestHovered, setIsInterestHovered] = useState(false);
  const [anchorInterestEl, setAnchorInterestEl] = useState(null);

  const handleInterestClick = (event, bsDetails) => {
    setAnchorInterestEl(event.currentTarget);
    setSelectedBsDetails(bsDetails);
    setInterestDialogOpen(true);
  };

  const handleInterestMouseLeave = () => {
    setTimeout(() => {
      setIsInterestHovered(false);
    }, 1500);
  };

  const [isVenAgentDialogOpen, setVenAgentDialogOpen] = useState(false);
  const [isVenAgentHovered, setIsVenAgentHovered] = useState(null);
  const [anchorVenAgentEl, setAnchorVenAgentEl] = useState(null);

  const handleVenAgentClick = (event, agentDetails) => {
    setAnchorVenAgentEl(event.currentTarget);
    setVenAgentDialogOpen(true);
  };

  const handleVenAgentMouseLeave = () => {
    setTimeout(() => {
      setIsVenAgentHovered(null);
    }, 1500);
  };

  const [isBuyingAgentDialogOpen, setBuyingAgentDialogOpen] = useState(false);
  const [isBuyingAgentHovered, setIsBuyingAgentHovered] = useState(null);
  const [anchorBuyingAgentEl, setAnchorBuyingAgentEl] = useState(null);

  const handleBuyingAgentClick = (event) => {
    setAnchorBuyingAgentEl(event.currentTarget);
    setBuyingAgentDialogOpen(true);
  };

  const handleBuyingAgentMouseLeave = () => {
    setTimeout(() => {
      setIsBuyingAgentHovered(null);
    }, 1500);
  };

  const [isBuyingVendorDialogOpen, setBuyingVendorDialogOpen] = useState(false);
  const [isBuyingVendorHovered, setIsBuyingVendorHovered] = useState(null);
  const [anchorBuyingVendorEl, setAnchorBuyingVendorEl] = useState(null);

  const handleBuyingVendorClick = (event) => {
    setAnchorBuyingVendorEl(event.currentTarget);
    setBuyingVendorDialogOpen(true);
  };

  const handleBuyingVendorMouseLeave = () => {
    setTimeout(() => {
      setIsBuyingVendorHovered(null);
    }, 1500);
  };

  const handleActionRequiredClick = ({
    buyerId,
    propertyId,
    propertyAddress,
    status,
  }) => {
    setFileManagerBuyerId(buyerId);

    setSelectedPropertyAddress({
      buyerId,
      propertyId,
      propertyAddress,
      status,
    });

    setIsOpenFileManagerDialog(true);
    setIsFromVendorSolicitor(true);
    setIsFromBuyerSolicitor(false);
  };

  return row?.length < 1 ? (
    <TableRow>
      <TableCell style={{ padding: 0 }} colSpan={11}>
        <Collapse
          in={buyerTable[`${active ? 'active' : 'inactive'}-${index}`]}
          timeout="auto"
          unmountOnExit
        >
          <Grid
            container
            direction={'column'}
            sx={{
              background: '#4CA4D61A',
              padding: '5px 0px',
              borderRadius: '5px',
              fontFamily: 'poppins',
            }}
          >
            <Typography
              sx={{
                color: '#4CA4D6',
                fontWeight: 500,
                paddingLeft: '20px',
                fontFamily: 'poppins',
              }}
            >
              No {selectedcategorybuying ? 'Buying' : 'Selling'} Details
              available
            </Typography>
          </Grid>
        </Collapse>
      </TableCell>
    </TableRow>
  ) : (
    <>
      <TableRow>
        <TableCell style={{ padding: 0 }} colSpan={11}>
          <Collapse
            in={buyerTable[`${active ? 'active' : 'inactive'}-${index}`]}
            timeout="auto"
            unmountOnExit
          >
            <Grid
              container
              direction={'column'}
              sx={{
                background: '#4CA4D61A',
                padding: '5px 0px',
                borderRadius: '5px',
                fontFamily: 'poppins',
              }}
            >
              <Typography
                sx={{
                  color: '#4CA4D6',
                  fontWeight: 500,
                  paddingLeft: '20px',
                  fontFamily: 'poppins',
                }}
              >
                {selectedcategorybuying ? 'Buying' : 'Selling'}
              </Typography>
            </Grid>
          </Collapse>
        </TableCell>
      </TableRow>
      <TableRow>
        {!selectedcategorybuying && (
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={11}>
            <Collapse
              in={buyerTable[`${active ? 'active' : 'inactive'}-${index}`]}
              timeout="auto"
              unmountOnExit
            >
              <Table
                aria-labelledby="tableTitle"
                size="medium"
                sx={{ backgroundColor: 'rgba(76, 164, 214, 0.03)' }}
              >
                <TableHead>
                  <TableRow>
                    {Sellingfirstcells?.map((headCell) => (
                      <TableCell
                        align="left"
                        sx={{
                          ...poppins400,
                          ...fontsize10,
                          color: '#666666',
                        }}
                      >
                        <TableSortLabel>
                          {headCell.label}
                          {buyerTable[index]}
                          <Box component="span" sx={visuallyHidden}></Box>
                        </TableSortLabel>
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Array.isArray(row) &&
                    row.length > 0 &&
                    row.map((item, index) => {
                      const { timerStatus, stage, isReset } =
                        item?.timerDetails || {};

                      const stageLabel = !timerStatus
                        ? ''
                        : timerStatus === 'End'
                        ? 'ENDED'
                        : stage === 'ST1'
                        ? 'STAGE 1'
                        : stage === 'ST2' && isReset === '1'
                        ? 'STAGE 2 - FINAL OFFERS'
                        : 'STAGE 2';

                      const stageColor = !timerStatus
                        ? 'transparent'
                        : timerStatus === 'End'
                        ? '#585858'
                        : stage === 'ST1'
                        ? '#10D35E'
                        : '#F93939';
                      const agentAgencyName =
                        item?.agentDetails?.agentAgencyName;
                      return (
                        <React.Fragment key={index}>
                          <TableRow>
                            <TableCell width={'10%'}>
                              <Typography
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  fontFamily: 'poppins',
                                  color: '#112347',
                                  fontWeight: 400,
                                  whiteSpace: 'nowrap',
                                }}
                              >
                                <HomeIcon /> &nbsp; {item?.propertyAddress}
                                {/* <KeyboardArrowDownIcon /> */}
                                {buyerDropdown != index ? (
                                  <IconButton
                                    onClick={() => setBuyerDropdown(index)}
                                  >
                                    <KeyboardArrowDownIcon />
                                  </IconButton>
                                ) : (
                                  <IconButton
                                    onClick={() => setBuyerDropdown(null)}
                                  >
                                    <KeyboardArrowUpIcon />
                                  </IconButton>
                                )}
                              </Typography>
                            </TableCell>

                            <TableCell>
                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '20px',
                                }}
                              >
                                <PropertyTimer
                                  propertyData={item?.timerDetails}
                                  solidash={true}
                                />
                                <Grid
                                  sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    gap: '10px',
                                  }}
                                >
                                  {item?.timerDetails?.timerStatus ==
                                    'Pause' && (
                                    <Box>
                                      <PauseIcon width={30} height={30} />
                                    </Box>
                                  )}
                                  <Typography
                                    sx={{
                                      background: stageColor,
                                      padding: '3px 10px',
                                      color: 'white',
                                      fontFamily: 'Poppins',
                                      borderRadius: '5px',
                                      height: '30px',
                                      whiteSpace: 'nowrap',
                                    }}
                                  >
                                    {stageLabel}
                                  </Typography>
                                </Grid>
                              </Box>
                            </TableCell>
                            <TableCell colSpan={5}></TableCell>

                            <TableCell>
                              {agentAgencyName && (
                                <Box>
                                  <AgencyBadge
                                    name={agentAgencyName}
                                    variant="solicitor"
                                  />
                                </Box>
                              )}
                            </TableCell>

                            <TableCell width={'10%'}>
                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'left',
                                  gap: '30px',
                                  marginLeft: 'auto',
                                }}
                              >
                                <Box
                                  sx={{
                                    position: 'relative',
                                    display: 'inline-flex',
                                  }}
                                >
                                  {item?.agentDetails?.profileImage == '' ||
                                  item?.agentDetails?.profileImage == null ? (
                                    <Avatar
                                      style={{
                                        width: '36px',
                                        height: '37px',
                                        fontFamily: 'poppins',
                                        backgroundColor: '#666666',
                                      }}
                                    >
                                      {item?.agentDetails?.agentName?.charAt(
                                        0
                                      ) +
                                        item?.agentDetails?.agentSurName?.charAt(
                                          0
                                        )}
                                    </Avatar>
                                  ) : (
                                    <Avatar
                                      alt={
                                        item?.agentDetails?.agentName?.charAt(
                                          0
                                        ) +
                                        item?.agentDetails?.agentSurName?.charAt(
                                          0
                                        )
                                      }
                                      src={item?.agentDetails?.profileImage}
                                      style={{
                                        width: '36px',
                                        height: '37px',
                                      }}
                                    />
                                  )}
                                </Box>
                                <Box sx={{ position: 'relative' }}>
                                  <Typography sx={imageCont}>
                                    <Typography
                                      sx={{
                                        fontSize: '12px',
                                        fontFamily: 'Poppins',
                                        fontWeight: '400',
                                        cursor: 'pointer',
                                      }}
                                    >
                                      <Typography
                                        sx={{
                                          fontSize: '12px',
                                          fontFamily: 'Poppins',
                                          fontWeight: '400',
                                          whiteSpace: 'nowrap',
                                        }}
                                      >
                                        {item?.agentDetails?.agentName +
                                          ' ' +
                                          item?.agentDetails?.agentSurName}
                                      </Typography>
                                    </Typography>
                                  </Typography>
                                </Box>
                                <Box
                                  sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '5px',
                                  }}
                                >
                                  <Grid
                                    onClick={() => {
                                      if (
                                        item?.agentDetails?.binderId == null
                                      ) {
                                        setShowSellingDialog(true);
                                      } else {
                                        directcomm(
                                          item?.agentDetails?.binderId
                                        );
                                      }
                                    }}
                                    style={{ cursor: 'pointer' }}
                                  >
                                    <MessageNew />
                                  </Grid>
                                  <Grid
                                    style={{ cursor: 'pointer' }}
                                    onMouseEnter={() =>
                                      setIsVenAgentHovered(index)
                                    }
                                    onMouseLeave={handleVenAgentMouseLeave}
                                    onClick={() => {
                                      // window.scrollTo(0, 0);
                                      // setMessage(true);
                                      // setChangestab(true);
                                      // localStorage.setItem(
                                      //   'dialId',
                                      //   item?.agentDetails?.agentEmail
                                      // );
                                      // setShowMessage(true);
                                      // setMessagedata({ incomingcall: true });
                                      return window.open(
                                        `tel:` + item?.agentDetails?.agentMobile
                                      );
                                    }}
                                  >
                                    <CallNew />
                                  </Grid>

                                  {/* <Grid
                                    sx={{
                                      display: 'flex',
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      marginTop: '3px',
                                      cursor: 'pointer',
                                    }}
                                    onClick={(event) =>
                                      handleVenAgentClick(
                                        event,
                                        item?.agentDetails
                                      )
                                    }
                                  >
                                    {isVenAgentHovered == index && (
                                      <Calldownarrow />
                                    )}
                                  </Grid>
                                  <ContactPopOver
                                    name={item?.agentDetails?.agentName}
                                    surname={item?.agentDetails?.agentSurName}
                                    emailid={item?.agentDetails?.userEmail}
                                    mobilenum={item?.agentDetails?.agentMobile}
                                    isDialogOpen={isVenAgentDialogOpen}
                                    setDialogOpen={setVenAgentDialogOpen}
                                    anchorEl={anchorVenAgentEl}
                                    setAnchorEl={setAnchorVenAgentEl}
                                    solicitor={true}
                                    setMessage={setMessage}
                                    setChangestab={setChangestab}
                                  /> */}
                                </Box>
                              </Box>
                            </TableCell>

                            <Dialog
                              open={showSellingDialog}
                              onClose={handleSellingDialogCancel}
                              hideBackdrop
                              PaperProps={{
                                sx: {
                                  position: 'absolute',
                                  borderRadius: '8px',
                                  background: '#FFFFFF',
                                  border: '0.5px solid #D9D9D9',
                                  borderRadius: '8px',
                                  padding: '30px',
                                  boxShadow: 'none',
                                },
                              }}
                            >
                              <Grid
                                item
                                container
                                direction={'column'}
                                sx={{ gap: '20px' }}
                              >
                                <Grid
                                  item
                                  container
                                  sx={{ display: 'flex', alignItems: 'center' }}
                                >
                                  <Grid item>
                                    <Typography
                                      sx={{
                                        fontFamily: 'Poppins !important',
                                        fontStyle: 'normal !important',
                                        fontWeight: '500 !important',
                                        fontSize: matchessm ? '16px' : '24px',
                                        lineHeight: '36px',
                                        color: '#000000',
                                      }}
                                    >
                                      Binder not available
                                    </Typography>
                                  </Grid>
                                </Grid>
                                <Grid>
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '400 !important',
                                      fontSize: matchessm ? '12px' : '16px',
                                      color: '#666666',
                                    }}
                                  >
                                    Do you want to create binder with{' '}
                                    {item?.agentDetails?.agentName} {''}{' '}
                                    {item?.agentDetails?.agentSurName}?
                                  </Typography>
                                </Grid>
                                <Grid
                                  item
                                  container
                                  direction="row"
                                  justifyContent="flex-end"
                                  gap={2}
                                >
                                  <Grid item>
                                    <Button
                                      variant="outlined"
                                      style={{
                                        padding: matchessm
                                          ? '7px 20px'
                                          : '10px 39px',
                                        width: '100%',
                                        height: '41px',
                                        fontSize: '14px',
                                        color: '#666666',
                                        fontWeight: '400',
                                        fontFamily: 'Poppins',
                                        border:
                                          '1px solid rgba(17, 35, 71, 0.1)',
                                        borderRadius: '5px',
                                        textTransform: 'none',
                                      }}
                                      disabled={loading}
                                      onClick={handleSellingDialogCancel}
                                    >
                                      Cancel
                                    </Button>
                                  </Grid>
                                  <Grid item>
                                    <Button
                                      variant="outlined"
                                      style={{
                                        padding: matchessm
                                          ? '7px 20px'
                                          : '10px 39px',
                                        width: '100%',
                                        height: '41px',
                                        fontSize: '14px',
                                        color: '#FFFFFF',
                                        fontWeight: '400',
                                        fontFamily: 'Poppins',
                                        background: '#4ca4d6',
                                        borderRadius: '5px',
                                        textTransform: 'none',
                                      }}
                                      disabled={loading}
                                      onClick={() =>
                                        handleSellingDialogConfirm(
                                          item?.propertyId,
                                          item?.agentDetails?.agentId,
                                          item?.agentDetails?.userEmail
                                        )
                                      }
                                    >
                                      Confirm
                                    </Button>
                                  </Grid>
                                  {loading && (
                                    <Grid item>
                                      <img
                                        alt="Logo"
                                        src={Loading}
                                        className="loaderImage"
                                        style={{
                                          height: '40px',
                                          width: '40px',
                                        }}
                                      />
                                    </Grid>
                                  )}
                                </Grid>
                              </Grid>
                            </Dialog>
                            <TableCell>
                              <Box
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'left',
                                  alignItems: 'center',
                                  cursor: 'pointer',
                                  '& svg path': {
                                    fill: '#6c2ad2',
                                  },
                                }}
                                onClick={() => {
                                  scrollPositionRef.current =
                                    cardScrollRef.current?.scrollTop || 0;
                                  setIsOpenFileManager(true);
                                  setSelectedPropertyAddress(item);
                                  setIsFromVendorSolicitor(true);
                                  setIsFromBuyerSolicitor(false);
                                  setIsFileView(true);
                                  setStatustextpopup(
                                    `${item?.contractStatus || ''} / ${
                                      item?.WStatus || ''
                                    }`
                                  );
                                }}
                              >
                                <Filemanagericon width={23} height={23} />
                              </Box>
                            </TableCell>
                          </TableRow>

                          {/* <Buyerdownreg buyerDropdown={buyerDropdown} index={index} item={row} key={index} /> */}

                          {row[buyerDropdown]?.insterestedBuyerList.length <
                          1 ? (
                            <TableRow>
                              <TableCell style={{ padding: 0 }} colSpan={11}>
                                <Collapse
                                  in={buyerDropdown == index}
                                  timeout="auto"
                                  unmountOnExit
                                >
                                  <Grid
                                    container
                                    direction={'column'}
                                    sx={{
                                      background: '#4CA4D61A',
                                      padding: '5px 0px',
                                      borderRadius: '5px',
                                      fontFamily: 'poppins',
                                    }}
                                  >
                                    <Typography
                                      sx={{
                                        color: '#4CA4D6',
                                        fontWeight: 500,
                                        paddingLeft: '20px',
                                        fontFamily: 'poppins',
                                      }}
                                    >
                                      No interested buyer details available
                                    </Typography>
                                  </Grid>
                                </Collapse>
                              </TableCell>
                            </TableRow>
                          ) : (
                            <TableRow>
                              <TableCell
                                style={{ paddingBottom: 0, paddingTop: 0 }}
                                colSpan={11}
                              >
                                <Collapse
                                  in={buyerDropdown == index}
                                  timeout="auto"
                                  unmountOnExit
                                >
                                  <Table
                                    aria-labelledby="tableTitle"
                                    size="medium"
                                    sx={{
                                      backgroundColor:
                                        'rgba(76, 164, 214, 0.03)',
                                    }}
                                  >
                                    <TableHead>
                                      <TableRow>
                                        {sellingbuyerheadCells?.map(
                                          (headCell, index) => (
                                            <TableCell
                                              align="left"
                                              sx={{
                                                fontFamily: 'poppins',
                                                fontWeight:
                                                  index == 0 &&
                                                  !selectedcategorybuying
                                                    ? '500'
                                                    : '400',
                                                fontSize:
                                                  index == 0 &&
                                                  !selectedcategorybuying
                                                    ? '14px'
                                                    : '10px',
                                                color:
                                                  index == 0 &&
                                                  !selectedcategorybuying
                                                    ? '#6C2AD2'
                                                    : '#666666',
                                              }}
                                            >
                                              <TableSortLabel>
                                                {index == 0 &&
                                                !selectedcategorybuying
                                                  ? 'Interested Buyers'
                                                  : headCell.label}
                                                <Box
                                                  component="span"
                                                  sx={visuallyHidden}
                                                ></Box>
                                              </TableSortLabel>
                                            </TableCell>
                                          )
                                        )}
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {Array.isArray(
                                        row[buyerDropdown]?.insterestedBuyerList
                                      ) &&
                                        row[buyerDropdown]?.insterestedBuyerList
                                          .length > 0 &&
                                        row[
                                          buyerDropdown
                                        ]?.insterestedBuyerList.map(
                                          (actionitem, index) => {
                                            const formattedactionWETA = moment(
                                              actionitem?.WETA
                                            ).format('hh:mm A DD-MM-YYYY');
                                            const formattedactionContractETA =
                                              moment(
                                                actionitem?.contractETA
                                              ).format('hh:mm A DD-MM-YYYY');
                                            const propertyId =
                                              row[buyerDropdown]?.propertyId;
                                            const propertyAddress =
                                              row[buyerDropdown]
                                                ?.propertyAddress;
                                            return (
                                              <>
                                                <TableRow>
                                                  <TableCell>
                                                    <Typography
                                                      sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        fontFamily: 'poppins',
                                                        color: '#112347',
                                                        fontWeight: 400,
                                                        whiteSpace: 'nowrap',
                                                      }}
                                                    >
                                                      {actionitem?.buyerName +
                                                        ' ' +
                                                        actionitem?.buyerSurName}
                                                      {/* <KeyboardArrowDownIcon /> */}
                                                    </Typography>
                                                  </TableCell>
                                                  <TableCell>
                                                    <Box
                                                      sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '10px',
                                                      }}
                                                    >
                                                      <Box
                                                        sx={{
                                                          cursor: 'pointer',
                                                        }}
                                                        onClick={(event) =>
                                                          popOverFunc(
                                                            event,
                                                            'Property Inspected',
                                                            actionitem?.insLog ==
                                                              1
                                                              ? 'This buyer has inspected this property'
                                                              : 'This buyer has not yet inspected this property'
                                                          )
                                                        }
                                                      >
                                                        <EyeIcon
                                                          color={
                                                            actionitem?.insLog ==
                                                            1
                                                              ? '#2FCDFF'
                                                              : '#666666'
                                                          }
                                                        />
                                                      </Box>

                                                      <Box
                                                        sx={{
                                                          cursor: 'pointer',
                                                        }}
                                                        onClick={(event) =>
                                                          popOverFunc(
                                                            event,
                                                            'Contract Reviewed',
                                                            'Once you have forwarded the property purchase contract to your legal representative for review, you will be able to track the progress of the contract review. Once the review process is completed, any amendments or updates approved by the Vendor will be made available.'
                                                          )
                                                        }
                                                      >
                                                        <Receipt
                                                          color={
                                                            actionitem?.conLog ==
                                                            1
                                                              ? '#2FCDFF'
                                                              : '#666666'
                                                          }
                                                        />
                                                      </Box>

                                                      <Box
                                                        sx={{
                                                          cursor: 'pointer',
                                                        }}
                                                        onClick={(event) =>
                                                          popOverFunc(
                                                            event,
                                                            's66W Certificate',
                                                            'When buying a property in New South Wales (NSW) Australia, after the exchange of contracts, there is usually a five day cooling off period prior to the contract becoming binding and enforceable. The cooling off period can be waived by having your solicitor issue a s66W certificate. By submitting a signed s66W certificate, later when the sale contract is signed by both parties it will be immediately binding without any cooling off period.' +
                                                              'It  is common practice for buyers to include a signed s66W during the offering process to strengthen their offers.'
                                                          )
                                                        }
                                                      >
                                                        <Timer
                                                          color={
                                                            actionitem?.wLog ==
                                                            1
                                                              ? '#2FCDFF'
                                                              : '#666666'
                                                          }
                                                        />
                                                      </Box>
                                                    </Box>
                                                  </TableCell>
                                                  <TableCell
                                                    onClick={
                                                      actionitem?.contractStatus ===
                                                        'Completed' ||
                                                      actionitem?.contractStatus ===
                                                        'Requested' ||
                                                      actionitem?.contractStatus ===
                                                        'In Progress'
                                                        ? () =>
                                                            handleActionRequiredClick(
                                                              {
                                                                buyerId:
                                                                  actionitem?.buyerId,
                                                                propertyId:
                                                                  row[
                                                                    buyerDropdown
                                                                  ]?.propertyId,
                                                                propertyAddress:
                                                                  row[
                                                                    buyerDropdown
                                                                  ]
                                                                    ?.propertyAddress,
                                                                status:
                                                                  actionitem?.contractStatus,
                                                              }
                                                            )
                                                        : undefined
                                                    }
                                                    sx={{
                                                      cursor:
                                                        actionitem?.contractStatus ===
                                                          'Completed' ||
                                                        actionitem?.contractStatus ===
                                                          'Requested' ||
                                                        actionitem?.contractStatus ===
                                                          'In Progress'
                                                          ? 'pointer'
                                                          : 'default',
                                                      '&:hover': {
                                                        cursor:
                                                          actionitem?.contractStatus ===
                                                            'Completed' ||
                                                          actionitem?.contractStatus ===
                                                            'Requested' ||
                                                          actionitem?.contractStatus ===
                                                            'In Progress'
                                                            ? 'pointer'
                                                            : 'default',
                                                      },
                                                    }}
                                                  >
                                                    {actionitem?.contractStatus ===
                                                    'Completed' ? (
                                                      <Typography
                                                        sx={{
                                                          background:
                                                            getColor(
                                                              'Completed'
                                                            ),
                                                          padding: '3px 40px',
                                                          color: 'white',
                                                          fontFamily: 'poppins',
                                                          borderRadius: '5px',
                                                          whiteSpace: 'nowrap',
                                                        }}
                                                      >
                                                        Completed
                                                      </Typography>
                                                    ) : actionitem?.contractStatus ===
                                                        'Requested' ||
                                                      actionitem?.contractStatus ===
                                                        'In Progress' ? (
                                                      <Typography
                                                        sx={{
                                                          background:
                                                            getColor(
                                                              'Action required'
                                                            ),
                                                          padding: '3px 40px',
                                                          color: 'white',
                                                          fontFamily: 'poppins',
                                                          borderRadius: '5px',
                                                          whiteSpace: 'nowrap',
                                                        }}
                                                      >
                                                        Action Required
                                                      </Typography>
                                                    ) : (
                                                      <Typography
                                                        sx={{
                                                          fontFamily: 'poppins',
                                                          whiteSpace: 'nowrap',
                                                          color: '#999999',
                                                        }}
                                                      >
                                                        –
                                                      </Typography>
                                                    )}
                                                  </TableCell>

                                                  <TableCell>
                                                    {actionitem?.WStatus ===
                                                    'Completed' ? (
                                                      <Typography
                                                        sx={{
                                                          background: getColor(
                                                            actionitem?.WStatus
                                                          ),
                                                          padding: '3px 40px',
                                                          color: 'white',
                                                          fontFamily: 'poppins',
                                                          borderRadius: '5px',
                                                          whiteSpace: 'nowrap',
                                                        }}
                                                      >
                                                        Completed
                                                      </Typography>
                                                    ) : (
                                                      <Typography
                                                        sx={{
                                                          fontFamily: 'poppins',
                                                          whiteSpace: 'nowrap',
                                                          color: '#999999',
                                                        }}
                                                      >
                                                        –
                                                      </Typography>
                                                    )}
                                                  </TableCell>

                                                  <TableCell width={'10%'}>
                                                    {actionitem?.bsDetails !=
                                                    null ? (
                                                      <Box
                                                        sx={{
                                                          display: 'flex',
                                                          alignItems: 'center',
                                                          justifyContent:
                                                            'left',
                                                          gap: '30px',
                                                          marginLeft: 'auto',
                                                        }}
                                                      >
                                                        <Box
                                                          sx={{
                                                            position:
                                                              'relative',
                                                            display:
                                                              'inline-flex',
                                                          }}
                                                        >
                                                          {actionitem?.bsDetails
                                                            ?.profileImage ==
                                                            '' ||
                                                          actionitem?.bsDetails
                                                            ?.profileImage ==
                                                            null ? (
                                                            <Avatar
                                                              style={{
                                                                backgroundColor:
                                                                  '#666666',
                                                              }}
                                                            >
                                                              {actionitem?.bsDetails?.bsName?.charAt(
                                                                0
                                                              ) +
                                                                actionitem?.bsDetails?.bsSurname?.charAt(
                                                                  0
                                                                )}
                                                            </Avatar>
                                                          ) : (
                                                            <Avatar
                                                              alt={
                                                                actionitem?.bsDetails?.bsName?.charAt(
                                                                  0
                                                                ) +
                                                                actionitem?.bsDetails?.bsSurname?.charAt(
                                                                  0
                                                                )
                                                              }
                                                              src={
                                                                actionitem
                                                                  ?.bsDetails
                                                                  ?.profileImage
                                                              }
                                                              style={{
                                                                width: '36px',
                                                                height: '37px',
                                                              }}
                                                            />
                                                          )}
                                                        </Box>
                                                        <Box
                                                          sx={{
                                                            position:
                                                              'relative',
                                                          }}
                                                        >
                                                          <Typography
                                                            sx={imageCont}
                                                          >
                                                            <Typography
                                                              sx={{
                                                                fontSize:
                                                                  '12px',
                                                                fontFamily:
                                                                  'Poppins',
                                                                fontWeight:
                                                                  '400',
                                                                cursor:
                                                                  'pointer',
                                                              }}
                                                            >
                                                              <Typography
                                                                sx={{
                                                                  fontSize:
                                                                    '12px',
                                                                  fontFamily:
                                                                    'Poppins',
                                                                  fontWeight:
                                                                    '400',
                                                                  whiteSpace:
                                                                    'nowrap',
                                                                }}
                                                              >
                                                                {actionitem
                                                                  ?.bsDetails
                                                                  ?.bsName +
                                                                  ' ' +
                                                                  actionitem
                                                                    ?.bsDetails
                                                                    ?.bsSurname}
                                                              </Typography>
                                                            </Typography>
                                                          </Typography>
                                                        </Box>
                                                        <Box
                                                          sx={{
                                                            display: 'flex',
                                                            flexDirection:
                                                              'row',
                                                            gap: '15px',
                                                          }}
                                                        >
                                                          <Grid
                                                            onClick={() => {
                                                              if (
                                                                actionitem
                                                                  ?.bsDetails
                                                                  ?.binderId ==
                                                                null
                                                              ) {
                                                                handleInterestDialogOpen(
                                                                  actionitem?.bsDetails
                                                                );
                                                              } else {
                                                                directcomm(
                                                                  actionitem
                                                                    ?.bsDetails
                                                                    ?.binderId
                                                                );
                                                              }
                                                            }}
                                                            style={{
                                                              cursor: 'pointer',
                                                            }}
                                                          >
                                                            <MessageNew />
                                                          </Grid>
                                                          <Dialog
                                                            open={
                                                              showInterestDialog
                                                            }
                                                            onClose={
                                                              handleInterestDialogCancel
                                                            }
                                                            PaperProps={{
                                                              sx: {
                                                                position:
                                                                  'absolute',
                                                                borderRadius:
                                                                  '8px',
                                                                background:
                                                                  '#FFFFFF',
                                                                border:
                                                                  '0.5px solid #D9D9D9',
                                                                borderRadius:
                                                                  '8px',
                                                                padding: '30px',
                                                              },
                                                            }}
                                                          >
                                                            <Grid
                                                              item
                                                              container
                                                              direction={
                                                                'column'
                                                              }
                                                              sx={{
                                                                gap: '20px',
                                                              }}
                                                            >
                                                              <Grid
                                                                item
                                                                container
                                                                sx={{
                                                                  display:
                                                                    'flex',
                                                                  alignItems:
                                                                    'center',
                                                                }}
                                                              >
                                                                <Grid item>
                                                                  <Typography
                                                                    sx={{
                                                                      fontFamily:
                                                                        'Poppins !important',
                                                                      fontStyle:
                                                                        'normal !important',
                                                                      fontWeight:
                                                                        '500 !important',
                                                                      fontSize:
                                                                        matchessm
                                                                          ? '16px'
                                                                          : '24px',
                                                                      lineHeight:
                                                                        '36px',
                                                                      color:
                                                                        '#000000',
                                                                    }}
                                                                  >
                                                                    Binder not
                                                                    available
                                                                  </Typography>
                                                                </Grid>
                                                              </Grid>
                                                              <Grid>
                                                                <Typography
                                                                  sx={{
                                                                    fontFamily:
                                                                      'Poppins !important',
                                                                    fontStyle:
                                                                      'normal !important',
                                                                    fontWeight:
                                                                      '400 !important',
                                                                    fontSize:
                                                                      matchessm
                                                                        ? '12px'
                                                                        : '16px',
                                                                    color:
                                                                      '#666666',
                                                                  }}
                                                                >
                                                                  Do you want to
                                                                  create binder
                                                                  with{' '}
                                                                  {
                                                                    selectedBsDetails?.bsName
                                                                  }{' '}
                                                                  {''}{' '}
                                                                  {
                                                                    selectedBsDetails?.bsSurname
                                                                  }
                                                                  ?
                                                                </Typography>
                                                              </Grid>
                                                              <Grid
                                                                item
                                                                container
                                                                direction="row"
                                                                justifyContent="flex-end"
                                                                gap={2}
                                                              >
                                                                <Grid item>
                                                                  <Button
                                                                    variant="outlined"
                                                                    style={{
                                                                      padding:
                                                                        matchessm
                                                                          ? '7px 20px'
                                                                          : '10px 39px',
                                                                      width:
                                                                        '100%',
                                                                      height:
                                                                        '41px',
                                                                      fontSize:
                                                                        '14px',
                                                                      color:
                                                                        '#666666',
                                                                      fontWeight:
                                                                        '400',
                                                                      fontFamily:
                                                                        'Poppins',
                                                                      border:
                                                                        '1px solid rgba(17, 35, 71, 0.1)',
                                                                      borderRadius:
                                                                        '5px',
                                                                      textTransform:
                                                                        'none',
                                                                    }}
                                                                    disabled={
                                                                      loading
                                                                    }
                                                                    onClick={
                                                                      handleInterestDialogCancel
                                                                    }
                                                                  >
                                                                    Cancel
                                                                  </Button>
                                                                </Grid>
                                                                <Grid item>
                                                                  <Button
                                                                    variant="outlined"
                                                                    style={{
                                                                      padding:
                                                                        matchessm
                                                                          ? '7px 20px'
                                                                          : '10px 39px',
                                                                      width:
                                                                        '100%',
                                                                      height:
                                                                        '41px',
                                                                      fontSize:
                                                                        '14px',
                                                                      color:
                                                                        '#FFFFFF',
                                                                      fontWeight:
                                                                        '400',
                                                                      fontFamily:
                                                                        'Poppins',
                                                                      background:
                                                                        '#4ca4d6',
                                                                      borderRadius:
                                                                        '5px',
                                                                      textTransform:
                                                                        'none',
                                                                    }}
                                                                    disabled={
                                                                      loading
                                                                    }
                                                                    onClick={() =>
                                                                      handleInterestDialogConfirm(
                                                                        item?.propertyId,
                                                                        selectedBsDetails?.bsId,
                                                                        selectedBsDetails?.bsEmail
                                                                      )
                                                                    }
                                                                  >
                                                                    Confirm
                                                                  </Button>
                                                                </Grid>
                                                                {loading && (
                                                                  <Grid item>
                                                                    <img
                                                                      alt="Logo"
                                                                      src={
                                                                        Loading
                                                                      }
                                                                      className="loaderImage"
                                                                      style={{
                                                                        height:
                                                                          '40px',
                                                                        width:
                                                                          '40px',
                                                                      }}
                                                                    />
                                                                  </Grid>
                                                                )}
                                                              </Grid>
                                                            </Grid>
                                                          </Dialog>
                                                          <Grid
                                                            style={{
                                                              cursor: 'pointer',
                                                            }}
                                                            onMouseEnter={() =>
                                                              setIsInterestHovered(
                                                                true
                                                              )
                                                            }
                                                            onMouseLeave={
                                                              handleInterestMouseLeave
                                                            }
                                                            onClick={() => {
                                                              // window.scrollTo(
                                                              //   0,
                                                              //   0
                                                              // );

                                                              // setMessage(true);
                                                              // setChangestab(
                                                              //   true
                                                              // );
                                                              // localStorage.setItem(
                                                              //   'dialId',
                                                              //   actionitem
                                                              //     ?.bsDetails
                                                              //     ?.bsEmail
                                                              // );
                                                              // setShowMessage(
                                                              //   true
                                                              // );
                                                              // setMessagedata({
                                                              //   incomingcall: true,
                                                              // });
                                                              return window.open(
                                                                `tel:` +
                                                                  selectedBsDetails?.bsMobile
                                                              );
                                                            }}
                                                          >
                                                            <CallNew />
                                                          </Grid>

                                                          {/* <Grid
                                                            sx={{
                                                              display: 'flex',
                                                              justifyContent:
                                                                'center',
                                                              alignItems:
                                                                'center',
                                                              marginTop: '3px',
                                                              cursor: 'pointer',
                                                            }}
                                                            onClick={(event) =>
                                                              handleInterestClick(
                                                                event,
                                                                actionitem?.bsDetails
                                                              )
                                                            }
                                                          >
                                                            {isInterestHovered && (
                                                              <Calldownarrow />
                                                            )}
                                                          </Grid>
                                                          <ContactPopOver
                                                            name={
                                                              selectedBsDetails?.bsName
                                                            }
                                                            surname={
                                                              selectedBsDetails?.bsSurname
                                                            }
                                                            emailid={
                                                              selectedBsDetails?.bsEmail
                                                            }
                                                            mobilenum={
                                                              selectedBsDetails?.bsMobile
                                                            }
                                                            isDialogOpen={
                                                              isInterestDialogOpen
                                                            }
                                                            setDialogOpen={
                                                              setInterestDialogOpen
                                                            }
                                                            anchorEl={
                                                              anchorInterestEl
                                                            }
                                                            setAnchorEl={
                                                              setAnchorInterestEl
                                                            }
                                                            solicitor={true}
                                                            setMessage={
                                                              setMessage
                                                            }
                                                            setChangestab={
                                                              setChangestab
                                                            }
                                                          /> */}
                                                        </Box>
                                                      </Box>
                                                    ) : (
                                                      <Typography
                                                        sx={{
                                                          color: '#999999',
                                                        }}
                                                      >
                                                        -
                                                      </Typography>
                                                    )}
                                                  </TableCell>
                                                </TableRow>
                                              </>
                                            );
                                          }
                                        )}
                                    </TableBody>
                                  </Table>
                                </Collapse>
                              </TableCell>
                            </TableRow>
                          )}
                        </React.Fragment>
                      );
                    })}
                </TableBody>
              </Table>
            </Collapse>
          </TableCell>
        )}
      </TableRow>

      {selectedcategorybuying && (
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={11}>
            <Collapse
              in={buyerTable[`${active ? 'active' : 'inactive'}-${index}`]}
              timeout="auto"
              unmountOnExit
            >
              <Table
                aria-labelledby="tableTitle"
                size="medium"
                sx={{ backgroundColor: 'rgba(76, 164, 214, 0.03)' }}
              >
                <TableHead>
                  <TableRow>
                    {buyingheadCells?.map((headCell, index) => (
                      <TableCell
                        align="left"
                        sx={{
                          fontFamily: 'poppins',
                          fontWeight:
                            index == 0 && !selectedcategorybuying
                              ? '500'
                              : '400',
                          fontSize:
                            index == 0 && !selectedcategorybuying
                              ? '14px'
                              : '10px',
                          color:
                            index == 0 && !selectedcategorybuying
                              ? '#6C2AD2'
                              : '#666666',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        <TableSortLabel>
                          {index == 0 && !selectedcategorybuying
                            ? 'Interested Buyers'
                            : headCell.label}
                          <Box component="span" sx={visuallyHidden}></Box>
                        </TableSortLabel>
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Array.isArray(row) &&
                    row.length > 0 &&
                    row.map((item, index) => {
                      const formattedBuyingContractETA = moment(
                        item?.contractETA
                      ).format('hh:mm A DD-MM-YYYY');
                      const formattedBuyingWETA = moment(item?.WETA).format(
                        'hh:mm A DD-MM-YYYY'
                      );
                      const isRowDisabled =
                        item?.propertyIsLinked == 0 ||
                        (item?.WStatus == 'Completed' &&
                          item?.contractStatus == 'Completed');

                      const uniqueRevokeKey = `${item?.buyerId}-${item?.propertyId}`;
                      const isItemRevoked =
                        revoked[uniqueRevokeKey] || item?.isRevoked == 1;

                      return (
                        <>
                          <TableRow
                            key={index}
                            sx={{
                              backgroundColor: 'transparent',
                              pointerEvents: 'auto',
                            }}
                          >
                            <TableCell>
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'flex-start',
                                  textAlign: 'center',
                                }}
                              >
                                <div
                                  style={{
                                    display: 'inline-block',
                                    transform: 'scale(0.75)',
                                    marginTop: '-5px',
                                  }}
                                >
                                  <HomeIcon />
                                </div>
                                <Typography
                                  sx={{
                                    fontFamily: 'poppins',
                                    color: '#112347',
                                    fontWeight: 400,
                                    fontSize: matchessm ? '12px' : '16px',
                                  }}
                                >
                                  {item?.propertyAddress}
                                </Typography>
                              </div>

                              {active &&
                                item?.timerDetails?.timerStatus != 'End' &&
                                item?.conLog != 1 &&
                                item?.wLog != 1 && (
                                  <Box
                                    sx={{
                                      cursor: isItemRevoked
                                        ? 'default'
                                        : 'pointer',
                                      backgroundColor: isItemRevoked
                                        ? '#F93939'
                                        : 'rgba(240, 240, 240, 1)',
                                      color: isItemRevoked
                                        ? '#FFFFFF'
                                        : '#F93939',
                                      mt: '5px',
                                      padding: '0px 6px',
                                      display: 'inline-block',
                                      borderRadius: '5px',
                                      '&:hover': !isItemRevoked && {
                                        backgroundColor: '#F93939',
                                        color: '#FFFFFF',
                                      },
                                    }}
                                    onClick={() =>
                                      !isItemRevoked &&
                                      handleRevoke(
                                        item?.buyerId,
                                        item?.propertyId,
                                        index,
                                        item?.buyerName,
                                        item?.buyerSurName
                                      )
                                    }
                                  >
                                    <Typography
                                      sx={{
                                        ...poppins400,
                                        fontSize: '12px',
                                        textTransform: 'none',
                                      }}
                                    >
                                      {isItemRevoked ? 'Revoked' : 'Revoke'}
                                    </Typography>
                                  </Box>
                                )}
                            </TableCell>
                            <TableCell>
                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '10px',
                                }}
                              >
                                <Box
                                  sx={{
                                    cursor: 'pointer',
                                    width: '40px',
                                    height: '40px',
                                  }}
                                  onClick={(event) =>
                                    popOverFunc(
                                      event,
                                      'Property Inspected',
                                      item?.insLog == 1
                                        ? 'This buyer has inspected this property'
                                        : 'This buyer has not yet inspected this property'
                                    )
                                  }
                                >
                                  <EyeIcon
                                    color={
                                      item?.insLog == 1 ? '#2FCDFF' : '#666666'
                                    }
                                  />
                                </Box>

                                <Box
                                  sx={{
                                    cursor: 'pointer',
                                    width: '40px',
                                    height: '40px',
                                  }}
                                  onClick={(event) =>
                                    popOverFunc(
                                      event,
                                      'Contract Reviewed',
                                      'Once you have forwarded the property purchase contract to your legal representative for review, you will be able to track the progress of the contract review. Once the review process is completed, any amendments or updates approved by the Vendor will be made available.'
                                    )
                                  }
                                >
                                  <Receipt
                                    color={
                                      item?.conLog == 1 ? '#2FCDFF' : '#666666'
                                    }
                                  />
                                </Box>

                                <Box
                                  sx={{
                                    cursor: 'pointer',
                                    width: '40px',
                                    height: '40px',
                                  }}
                                  onClick={(event) =>
                                    popOverFunc(
                                      event,
                                      's66W Certificate',
                                      'When buying a property in New South Wales (NSW) Australia, after the exchange of contracts, there is usually a five day cooling off period prior to the contract becoming binding and enforceable. The cooling off period can be waived by having your solicitor issue a s66W certificate. By submitting a signed s66W certificate, later when the sale contract is signed by both parties it will be immediately binding without any cooling off period.' +
                                        'It  is common practice for buyers to include a signed s66W during the offering process to strengthen their offers.'
                                    )
                                  }
                                >
                                  <Timer
                                    color={
                                      item?.wLog == 1 ? '#2FCDFF' : '#666666'
                                    }
                                  />
                                </Box>
                              </Box>
                            </TableCell>
                            <TableCell ref={anchorRef} sx={{ width: '200px' }}>
                              {!item?.contractUpdatedBy ? (
                                <Typography
                                  sx={{
                                    fontFamily: 'poppins',
                                    whiteSpace: 'nowrap',
                                    color: '#999999',
                                  }}
                                >
                                  –
                                </Typography>
                              ) : item?.contractUpdatedBy ==
                                userDetail?.userId ? (
                                item?.contractStatus === 'Action required' ? (
                                  <Typography
                                    sx={{
                                      fontFamily: 'poppins',
                                      whiteSpace: 'nowrap',
                                      color: '#999999',
                                    }}
                                  >
                                    –
                                  </Typography>
                                ) : (
                                  <Typography
                                    onClick={(event) => {
                                      if (
                                        item?.timerDetails?.timerStatus !=
                                          'Pause' &&
                                        item?.contractStatus !=
                                          'Action required' &&
                                        item?.isPropertyArchived !== 1
                                      ) {
                                        pendingStatus(event, item, 'Contract');
                                      }
                                      setPopupBinderId(item?.contractBinderId);
                                    }}
                                    sx={{
                                      display: 'inline-block',
                                      background:
                                        item?.contractStatus == 'Completed'
                                          ? '#08A742'
                                          : item?.contractStatus ===
                                            'In Progress'
                                          ? '#F93939'
                                          : 'grey',
                                      padding: '3px 0px',
                                      color: 'white',
                                      fontFamily: 'poppins',
                                      borderRadius: '5px',
                                      cursor:
                                        item?.timerDetails?.timerStatus ==
                                          'Pause' ||
                                        item?.isPropertyArchived == 1
                                          ? 'not-allowed'
                                          : 'pointer',
                                      whiteSpace: 'nowrap',
                                      width: '150px',
                                      boxSizing: 'border-box',
                                      textAlign: 'center',
                                    }}
                                  >
                                    {item?.contractStatus == 'In Progress'
                                      ? 'Action Required'
                                      : item?.contractStatus}
                                    {/* Action required */}
                                  </Typography>
                                )
                              ) : (
                                <Typography
                                  sx={{
                                    fontFamily: 'poppins',
                                    whiteSpace: 'nowrap',
                                    color: '#999999',
                                  }}
                                >
                                  –
                                </Typography>
                              )}
                            </TableCell>

                            <TableCell>
                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'flex-start',
                                }}
                              >
                                {item?.contractUpdatedBy !=
                                userDetail?.userId ? (
                                  <Typography
                                    sx={{
                                      fontFamily: 'poppins',
                                      whiteSpace: 'nowrap',
                                      color: '#999999',
                                    }}
                                  >
                                    –
                                  </Typography>
                                ) : item?.contractStatus == 'Completed' ? (
                                  <Tickicon />
                                ) : item?.contractETA ? (
                                  <>
                                    <Warningfunc
                                      selectedDate={item?.contractETA}
                                    />{' '}
                                    &nbsp;
                                    <Typography
                                      sx={{
                                        fontFamily: 'poppins',
                                        whiteSpace: 'nowrap',
                                      }}
                                    >
                                      {formattedBuyingContractETA}
                                    </Typography>
                                  </>
                                ) : (
                                  <Typography
                                    sx={{
                                      fontFamily: 'poppins',
                                      whiteSpace: 'nowrap',
                                      color: '#999999',
                                    }}
                                  >
                                    –
                                  </Typography>
                                )}
                              </Box>
                            </TableCell>
                            <TableCell>
                              {!item?.WUpdatedBy ? (
                                <Typography
                                  sx={{
                                    fontFamily: 'poppins',
                                    whiteSpace: 'nowrap',
                                    color: '#999999',
                                  }}
                                >
                                  –
                                </Typography>
                              ) : item?.WUpdatedBy == userDetail?.userId ? (
                                item?.WStatus === 'Action required' ? (
                                  <Typography
                                    sx={{
                                      fontFamily: 'poppins',
                                      whiteSpace: 'nowrap',
                                      textAlign: 'left',
                                      color: '#999999',
                                    }}
                                  >
                                    –
                                  </Typography>
                                ) : (
                                  <Typography
                                    onClick={(event) => {
                                      if (
                                        item?.WStatus != 'Action required' &&
                                        item?.timerDetails?.timerStatus !=
                                          'Pause' &&
                                        item?.isPropertyArchived !== 1
                                      ) {
                                        pendingStatus(event, item, '66W');
                                      }
                                      setPopupBinderId(item?.WBinderId);
                                    }}
                                    sx={{
                                      display: 'inline-block',
                                      background:
                                        item?.WStatus == 'Completed'
                                          ? '#08A742'
                                          : item?.WStatus === 'Requested'
                                          ? '#F93939'
                                          : 'grey',
                                      padding: '3px 0',
                                      color: 'white',
                                      fontFamily: 'poppins',
                                      borderRadius: '5px',
                                      cursor:
                                        item?.timerDetails?.timerStatus ==
                                          'Pause' ||
                                        item?.isPropertyArchived == 1
                                          ? 'not-allowed'
                                          : 'pointer',
                                      whiteSpace: 'nowrap',
                                      width: '150px',
                                      boxSizing: 'border-box',
                                      textAlign: 'center',
                                    }}
                                  >
                                    {item?.WStatus === 'Requested'
                                      ? 'Action Required'
                                      : item?.WStatus}
                                  </Typography>
                                )
                              ) : (
                                <Typography
                                  sx={{
                                    fontFamily: 'poppins',
                                    whiteSpace: 'nowrap',
                                    color: '#999999',
                                  }}
                                >
                                  –
                                </Typography>
                              )}
                            </TableCell>
                            <TableCell>
                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'flex-start',
                                }}
                              >
                                {item?.WUpdatedBy != userDetail?.userId ? (
                                  <Typography
                                    sx={{
                                      fontFamily: 'poppins',
                                      whiteSpace: 'nowrap',
                                      color: '#999999',
                                    }}
                                  >
                                    –
                                  </Typography>
                                ) : item?.WStatus == 'Completed' ? (
                                  <Tickicon />
                                ) : item?.WETA ? (
                                  <>
                                    <Warningfunc selectedDate={item?.WETA} />{' '}
                                    &nbsp;
                                    <Typography
                                      sx={{
                                        fontFamily: 'poppins',
                                        whiteSpace: 'nowrap',
                                      }}
                                    >
                                      {formattedBuyingWETA}
                                    </Typography>
                                  </>
                                ) : (
                                  <Typography
                                    sx={{
                                      fontFamily: 'poppins',
                                      whiteSpace: 'nowrap',
                                      color: '#999999',
                                    }}
                                  >
                                    –
                                  </Typography>
                                )}
                              </Box>
                            </TableCell>
                            <TableCell sx={{ alignItems: 'left' }}>
                              {/* <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '5px',
                                }}
                              > */}
                              <Stack
                                direction="row"
                                alignItems="center"
                                spacing={8}
                              >
                                {/* FIXED WIDTH TIMER */}
                                <Box
                                  sx={{
                                    width: 120,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                  }}
                                >
                                  <PropertyTimer
                                    propertyData={item?.timerDetails}
                                    solidash={true}
                                  />
                                </Box>

                                <Grid
                                  sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    alignItems: 'center',
                                    gap: '10px',
                                  }}
                                >
                                  {item?.timerDetails?.timerStatus ===
                                    'Pause' && (
                                    <Box
                                      sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <PauseIcon width={30} height={30} />
                                    </Box>
                                  )}
                                  {item?.timerDetails?.timerStatus ===
                                    'End' && (
                                    <Ended
                                      matches450={matches450}
                                      matchesB={matchesB}
                                      customStyles={{
                                        height: '30px',
                                        padding: '3px 10px',
                                      }}
                                    />
                                  )}
                                  {item?.timerDetails?.timerStatus !== 'End' &&
                                    item?.timerDetails?.stage === 'ST1' && (
                                      <Stage1
                                        matches450={matches450}
                                        matchesB={matchesB}
                                        customStyles={{
                                          height: '30px',
                                          padding: '3px 10px',
                                        }}
                                      />
                                    )}
                                  {item?.timerDetails?.timerStatus !== 'End' &&
                                    item?.timerDetails?.stage === 'ST2' &&
                                    item?.timerDetails?.isReset === '1' && (
                                      <Stage2Final
                                        matches450={matches450}
                                        matchesB={matchesB}
                                        customStyles={{
                                          height: '30px',
                                          padding: '3px 10px',
                                        }}
                                      />
                                    )}
                                  {item?.timerDetails?.timerStatus !== 'End' &&
                                    item?.timerDetails?.stage === 'ST2' &&
                                    item?.timerDetails?.isReset !== '1' && (
                                      <Stage2
                                        matches450={matches450}
                                        matchesB={matchesB}
                                        customStyles={{
                                          height: '30px',
                                          padding: '3px 10px',
                                        }}
                                      />
                                    )}
                                  {item?.timerDetails?.timerStatus !== 'End' &&
                                    item?.timerDetails?.stage !== 'ST1' &&
                                    item?.timerDetails?.stage !== 'ST2' && (
                                      <Typography
                                        sx={{
                                          fontFamily: 'Poppins',
                                          fontSize: '13px',
                                          color: 'white',
                                          padding: '3px 10px',
                                          background: '#529AEE',
                                          borderRadius: '5px',
                                          height: '30px',
                                          whiteSpace: 'nowrap',
                                          display: 'flex',
                                          alignItems: 'center',
                                        }}
                                      >
                                        Unpublished
                                      </Typography>
                                    )}
                                </Grid>
                              </Stack>

                              {/* </Box> */}
                            </TableCell>
                            <TableCell>
                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '10px',
                                  width: '100%',
                                }}
                              >
                                <Box
                                  sx={{
                                    position: 'relative',
                                    display: 'inline-flex',
                                    flexShrink: 0,
                                  }}
                                >
                                  {item?.agentDetails?.profileImage == '' ||
                                  item?.agentDetails?.profileImage == null ? (
                                    <Avatar
                                      style={{
                                        width: '36px',
                                        height: '37px',
                                        fontFamily: 'poppins',
                                        backgroundColor: '#666666',
                                      }}
                                    >
                                      {item?.agentDetails?.agentName?.charAt(0)}
                                      {item?.agentDetails?.agentSurName?.charAt(
                                        0
                                      )}
                                    </Avatar>
                                  ) : (
                                    <Avatar
                                      alt={
                                        item?.agentDetails?.agentName?.charAt(
                                          0
                                        ) +
                                        item?.agentDetails?.agentSurName?.charAt(
                                          0
                                        )
                                      }
                                      src={item?.agentDetails?.profileImage}
                                      sx={{
                                        width: '36px',
                                        height: '37px',
                                      }}
                                    />
                                  )}
                                </Box>

                                <Box
                                  sx={{
                                    display: 'grid',
                                    gridTemplateColumns: '180px 20px',
                                    columnGap: '8px',
                                    alignItems: 'center',
                                    minWidth: 0,
                                    flexShrink: 0,
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontSize: '12px',
                                      fontFamily: 'Poppins',
                                      fontWeight: 400,
                                      minWidth: 0,
                                      overflowWrap: 'break-word',
                                      wordBreak: 'break-word',
                                    }}
                                  >
                                    {item?.agentDetails?.agentName}{' '}
                                    {item?.agentDetails?.agentSurName}
                                  </Typography>

                                  <Box
                                    sx={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      gap: '5px',
                                      width: '30px',
                                      minWidth: '30px',
                                      maxWidth: '30px',
                                      flexShrink: 0,
                                    }}
                                  >
                                    <Grid
                                      onClick={() => handleShowDialog(item)}
                                      sx={{
                                        width: '30px',
                                        minWidth: '30px',
                                        height: '30px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        flexShrink: 0,
                                        cursor: 'pointer',
                                      }}
                                    >
                                      <MessageNew width={16} height={16} />
                                    </Grid>

                                    <Grid
                                      sx={{
                                        width: '30px',
                                        minWidth: '30px',
                                        height: '30px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        flexShrink: 0,
                                        cursor: 'pointer',
                                      }}
                                      onMouseEnter={() =>
                                        setIsBuyingAgentHovered(index)
                                      }
                                      onMouseLeave={handleBuyingAgentMouseLeave}
                                      onClick={() => {
                                        window.open(
                                          `tel:${item?.agentDetails?.agentMobile}`
                                        );
                                      }}
                                    >
                                      <CallNew width={16} height={16} />
                                    </Grid>
                                  </Box>
                                </Box>
                              </Box>
                            </TableCell>
                            <Dialog
                              open={showDialog}
                              onClose={handleDialogCancel}
                              hideBackdrop
                              PaperProps={{
                                sx: {
                                  position: 'absolute',
                                  borderRadius: '8px',
                                  background: '#FFFFFF',
                                  border: '0.5px solid #D9D9D9',
                                  borderRadius: '8px',
                                  padding: '30px',
                                  boxShadow: 'none',
                                },
                              }}
                            >
                              <Grid
                                item
                                container
                                direction={'column'}
                                sx={{ gap: '20px' }}
                              >
                                <Grid
                                  item
                                  container
                                  sx={{ display: 'flex', alignItems: 'center' }}
                                >
                                  <Grid item>
                                    <Typography
                                      sx={{
                                        fontFamily: 'Poppins !important',
                                        fontStyle: 'normal !important',
                                        fontWeight: '500 !important',
                                        fontSize: matchessm ? '16px' : '24px',
                                        lineHeight: '36px',
                                        color: '#000000',
                                      }}
                                    >
                                      Binder not available
                                    </Typography>
                                  </Grid>
                                </Grid>
                                <Grid>
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '400 !important',
                                      fontSize: matchessm ? '12px' : '16px',
                                      color: '#666666',
                                    }}
                                  >
                                    Do you want to create binder with{' '}
                                    {
                                      selectedAgentItemData?.agentDetails
                                        ?.agentName
                                    }{' '}
                                    {''}{' '}
                                    {
                                      selectedAgentItemData?.agentDetails
                                        ?.agentSurName
                                    }
                                    ?
                                  </Typography>
                                </Grid>
                                <Grid
                                  item
                                  container
                                  direction="row"
                                  justifyContent="flex-end"
                                  gap={2}
                                >
                                  <Grid item>
                                    <Button
                                      variant="outlined"
                                      style={{
                                        padding: matchessm
                                          ? '7px 20px'
                                          : '10px 39px',
                                        width: '100%',
                                        height: '41px',
                                        fontSize: '14px',
                                        color: '#666666',
                                        fontWeight: '400',
                                        fontFamily: 'Poppins',
                                        border:
                                          '1px solid rgba(17, 35, 71, 0.1)',
                                        borderRadius: '5px',
                                        textTransform: 'none',
                                      }}
                                      disabled={loading}
                                      onClick={handleDialogCancel}
                                    >
                                      Cancel
                                    </Button>
                                  </Grid>
                                  <Grid item>
                                    <Button
                                      variant="outlined"
                                      style={{
                                        padding: matchessm
                                          ? '7px 20px'
                                          : '10px 39px',
                                        width: '100%',
                                        height: '41px',
                                        fontSize: '14px',
                                        color: '#FFFFFF',
                                        fontWeight: '400',
                                        fontFamily: 'Poppins',
                                        background: '#4ca4d6',
                                        borderRadius: '5px',
                                        textTransform: 'none',
                                      }}
                                      disabled={loading}
                                      onClick={() =>
                                        handleDialogConfirm(
                                          selectedAgentItemData?.propertyId,
                                          selectedAgentItemData?.agentDetails
                                            ?.agentId,
                                          selectedAgentItemData?.agentDetails
                                            ?.userEmail
                                        )
                                      }
                                    >
                                      Confirm
                                    </Button>
                                  </Grid>
                                  {loading && (
                                    <Grid item>
                                      <img
                                        alt="Logo"
                                        src={Loading}
                                        className="loaderImage"
                                        style={{
                                          height: '40px',
                                          width: '40px',
                                        }}
                                      />
                                    </Grid>
                                  )}
                                </Grid>
                              </Grid>
                            </Dialog>

                            <TableCell>
                              <Box
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '10px',
                                  width: '100%',
                                  minWidth: 0,
                                }}
                              >
                                <Box
                                  sx={{
                                    position: 'relative',
                                    display: 'inline-flex',
                                    flexShrink: 0,
                                  }}
                                >
                                  {item?.vsDetails?.profileImage == '' ||
                                  item?.vsDetails?.profileImage == null ? (
                                    <Avatar
                                      style={{
                                        width: '36px',
                                        height: '37px',
                                        fontFamily: 'poppins',
                                        backgroundColor: '#666666',
                                      }}
                                    >
                                      {item?.vsDetails?.vsName
                                        ?.charAt(0)
                                        ?.toUpperCase()}
                                      {item?.vsDetails?.vsSurname
                                        ?.charAt(0)
                                        ?.toUpperCase()}
                                    </Avatar>
                                  ) : (
                                    <Avatar
                                      alt={
                                        item?.vsDetails?.vsName?.charAt(0) +
                                        item?.vsDetails?.vsSurname?.charAt(0)
                                      }
                                      src={item?.vsDetails?.profileImage}
                                      sx={{
                                        width: '36px',
                                        height: '37px',
                                      }}
                                    />
                                  )}
                                </Box>

                                <Box
                                  sx={{
                                    display: 'grid',
                                    gridTemplateColumns: '180px 20px',
                                    columnGap: '8px',
                                    alignItems: 'center',
                                    minWidth: 0,
                                    flexShrink: 0,
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      fontSize: '12px',
                                      fontFamily: 'Poppins',
                                      fontWeight: 400,
                                      minWidth: 0,
                                      overflowWrap: 'break-word',
                                      wordBreak: 'break-word',
                                    }}
                                  >
                                    {item?.vsDetails?.vsName}{' '}
                                    {item?.vsDetails?.vsSurname}
                                  </Typography>

                                  <Box
                                    sx={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      gap: '5px',
                                      width: '30px',
                                      minWidth: '30px',
                                      maxWidth: '30px',
                                      flexShrink: 0,
                                    }}
                                  >
                                    <Grid
                                      onClick={() =>
                                        handleShowVendorDialog(item)
                                      }
                                      sx={{
                                        width: '30px',
                                        height: '30px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        flexShrink: 0,
                                        cursor: 'pointer',
                                      }}
                                    >
                                      <MessageNew width={16} height={16} />
                                    </Grid>

                                    <Grid
                                      sx={{
                                        width: '30px',
                                        height: '30px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        cursor: 'pointer',
                                      }}
                                      onMouseEnter={() =>
                                        setIsBuyingVendorHovered(index)
                                      }
                                      onMouseLeave={handleBuyingAgentMouseLeave}
                                      onClick={() => {
                                        window.open(
                                          `tel:${item?.vsDetails?.vsMobile}`
                                        );
                                      }}
                                    >
                                      <CallNew width={16} height={16} />
                                    </Grid>
                                  </Box>
                                </Box>
                              </Box>
                            </TableCell>
                            <Dialog
                              open={showVendorDialog}
                              onClose={handleVendorDialogCancel}
                              hideBackdrop
                              PaperProps={{
                                sx: {
                                  position: 'absolute',
                                  borderRadius: '8px',
                                  background: '#FFFFFF',
                                  border: '0.5px solid #D9D9D9',
                                  borderRadius: '8px',
                                  padding: '30px',
                                  boxShadow: 'none',
                                },
                              }}
                            >
                              <Grid
                                item
                                container
                                direction={'column'}
                                sx={{ gap: '20px' }}
                              >
                                <Grid
                                  item
                                  container
                                  sx={{ display: 'flex', alignItems: 'center' }}
                                >
                                  <Grid item>
                                    <Typography
                                      sx={{
                                        fontFamily: 'Poppins !important',
                                        fontStyle: 'normal !important',
                                        fontWeight: '500 !important',
                                        fontSize: matchessm ? '16px' : '24px',
                                        lineHeight: '36px',
                                        color: '#000000',
                                      }}
                                    >
                                      Binder not available
                                    </Typography>
                                  </Grid>
                                </Grid>
                                <Grid>
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins !important',
                                      fontStyle: 'normal !important',
                                      fontWeight: '400 !important',
                                      fontSize: matchessm ? '12px' : '16px',
                                      color: '#666666',
                                    }}
                                  >
                                    Do you want to create binder with{' '}
                                    {selectedItem?.vsDetails?.vsName} {''}{' '}
                                    {selectedItem?.vsDetails?.vsSurname}?
                                  </Typography>
                                </Grid>
                                <Grid
                                  item
                                  container
                                  direction="row"
                                  justifyContent="flex-end"
                                  gap={2}
                                >
                                  <Grid item>
                                    <Button
                                      variant="outlined"
                                      style={{
                                        padding: matchessm
                                          ? '7px 20px'
                                          : '10px 39px',
                                        width: '100%',
                                        height: '41px',
                                        fontSize: '14px',
                                        color: '#666666',
                                        fontWeight: '400',
                                        fontFamily: 'Poppins',
                                        border:
                                          '1px solid rgba(17, 35, 71, 0.1)',
                                        borderRadius: '5px',
                                        textTransform: 'none',
                                      }}
                                      disabled={loading}
                                      onClick={handleVendorDialogCancel}
                                    >
                                      Cancel
                                    </Button>
                                  </Grid>
                                  <Grid item>
                                    <Button
                                      variant="outlined"
                                      style={{
                                        padding: matchessm
                                          ? '7px 20px'
                                          : '10px 39px',
                                        width: '100%',
                                        height: '41px',
                                        fontSize: '14px',
                                        color: '#FFFFFF',
                                        fontWeight: '400',
                                        fontFamily: 'Poppins',
                                        background: '#4ca4d6',
                                        borderRadius: '5px',
                                        textTransform: 'none',
                                      }}
                                      disabled={loading}
                                      onClick={() =>
                                        handleVendorDialogConfirm(
                                          selectedItem?.propertyId,
                                          selectedItem?.vsDetails?.vsId,
                                          selectedItem?.vsDetails?.vsEmail
                                        )
                                      }
                                    >
                                      Confirm
                                    </Button>
                                  </Grid>
                                  {loading && (
                                    <Grid item>
                                      <img
                                        alt="Logo"
                                        src={Loading}
                                        className="loaderImage"
                                        style={{
                                          height: '40px',
                                          width: '40px',
                                        }}
                                      />
                                    </Grid>
                                  )}
                                </Grid>
                              </Grid>
                            </Dialog>
                            <TableCell>
                              <Box
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  cursor: 'pointer',
                                  '& svg path': {
                                    fill: '#6c2ad2',
                                  },
                                }}
                                onClick={() => {
                                  scrollPositionRef.current =
                                    cardScrollRef.current?.scrollTop || 0;
                                  setSelectedPropertyAddress(item);
                                  setIsFromBuyerSolicitor(true);
                                  setIsFromVendorSolicitor(false);
                                  setIsFileView(true);
                                  setIsOpenFileManager(true);
                                  setStatustextpopup(
                                    `${item?.contractStatus || ''} / ${
                                      item?.WStatus || ''
                                    }`
                                  );
                                }}
                              >
                                <Filemanagericon width={23} height={23} />
                              </Box>
                            </TableCell>
                          </TableRow>
                        </>
                      );
                    })}
                </TableBody>
              </Table>
            </Collapse>
          </TableCell>
        </TableRow>
      )}
      <Popover
        id={idCheck}
        open={openCheck}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        sx={{ borderRadius: '10px' }}
      >
        <Grid
          container
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '15px',
            minWidth: matchessm ? 'auto' : '400px',
            maxWidth: matchessm ? 'auto' : '540px',
            marginTop: '-20px',
          }}
        >
          <Grid sx={{ padding: '0 30px', marginTop: '50px' }}>
            <Typography
              sx={{
                color: '#6C2AD2',
                fontFamily: 'poppins',
                fontSize: matchessm ? '14' : '16px',
                fontWeight: 500,
              }}
            >
              {name}
            </Typography>
          </Grid>
          <Grid sx={{ padding: '0 30px' }}>
            <Typography
              sx={{
                color: '#112347',
                fontFamily: 'poppins',
                fontSize: matchessm ? '12px' : '14px',
                fontWeight: 300,
              }}
            >
              {content}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Grid
              container
              justifyContent="space-between"
              alignItems={'center'}
              sx={{
                borderTop: '1px solid lightgrey',
                padding: '15px 20px',
                fontFamily: 'poppins',
                marginTop: '15px',
              }}
            >
              <Grid>
                <Typography
                  onClick={() => {
                    handleCloseCheck();
                    handleOpenHelpCenter();
                  }}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '5px',
                    color: '#112347',
                    fontFamily: 'poppins',
                    fontSize: matchessm ? '12px' : '14px',
                    fontWeight: 400,
                    margin: 0,
                    cursor: 'pointer',
                  }}
                >
                  <InfoIcon />
                  Need Help ?
                </Typography>
              </Grid>
              <Grid>
                <Button
                  onClick={handleCloseCheck}
                  sx={{
                    padding: matchessm ? '7px 20px' : '10px 30px',
                    color: 'grey',
                    fontFamily: 'poppins',
                    border: '1px solid lightgrey',
                    fontSize: matchessm ? '12px' : '',
                    textTransform: 'none',
                  }}
                  variant="outlined"
                >
                  Close
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Popover>

      <BuyerSolicitorStatusPopup
        idCheckPending={idCheckPending}
        openCheckPending={openCheckPending}
        setAnchorElPending={setAnchorElPending}
        anchorElPending={anchorElPending}
        address={address}
        selectedeta={selectedeta}
        setSelectedDate={setSelectedDate}
        selectedDate={selectedDate}
        statustext={statustext}
        minDate={minDate}
        handleDateChange={handleDateChange}
        Openmessage={Openmessage}
        popupBinderId={popupBinderId}
        propertyId={propertyId}
        buyerId={buyerId}
        createdDate={createdDate}
        updatedDate={updatedDate}
        contarctETADate={contarctETADate}
        ETAdialogChanged={ETAdialogChanged}
        handleCloseCheckPending={handleCloseCheckPending}
        setMessage={setMessage}
        Getuserlist={Getuserlist}
        confirmLoading={confirmLoading}
        setConfirmLoading={setConfirmLoading}
        url66W={url66W}
        primaryUserTypeValue={primaryUserTypeValue}
        selectedPropertyAddress={selectedPropertyAddress}
        anchorRef={anchorRef}
      />
    </>
  );
};

function SellerRegisterTable({ sellerTable, index }) {
  const { handleOpenHelpCenter } = React.useContext(datacontextsoli);
  const [name, setName] = useState('');
  const [content, setContent] = useState('');

  const [anchorEl, setAnchorEl] = useState(null);
  const handleCloseCheck = () => {
    setAnchorEl(null);
  };

  const openCheck = Boolean(anchorEl);
  const idCheck = openCheck ? 'simple-popover' : undefined;

  const [anchorElPending, setAnchorElPending] = useState(null);
  const handleCloseCheckPending = () => {
    setAnchorElPending(null);
  };

  const openCheckPendingS = Boolean(anchorElPending);
  const idCheckPending = openCheckPendingS ? 'simple-popover' : undefined;

  const popOverFunc = (event, name, content) => {
    setName(name);
    setContent(content);
    setAnchorEl(event.currentTarget);
  };

  const pendingStatus = (event) => {
    setAnchorElPending(event.currentTarget);
  };

  return (
    <TableRow>
      <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={11}>
        <Collapse in={sellerTable[index]} timeout="auto" unmountOnExit>
          <Grid
            container
            direction={'column'}
            sx={{
              background: '#6C2AD21A',
              padding: '5px',
              borderRadius: '5px',
              fontFamily: 'poppins',
            }}
          >
            <Typography
              sx={{
                color: '#6C2AD2',
                fontWeight: 500,
                paddingLeft: '10px',
                fontFamily: 'poppins',
              }}
            >
              Selling
            </Typography>
          </Grid>
          <Table sx={{ backgroundColor: 'rgba(76, 164, 214, 0.03)' }}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: '80px',
                overflowX: 'auto',
                borderBottom: '1px solid lightgrey',
                paddingBottom: '20px',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '40px',
                  justifyContent: 'start',
                }}
              >
                <Typography
                  sx={{
                    ...poppins400,
                    ...fontsize10,
                    color: '#666666',
                    whiteSpace: 'nowrap',
                  }}
                >
                  Property Address
                </Typography>
                <Typography
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    fontFamily: 'poppins',
                    color: '#112347',
                    fontWeight: 400,
                  }}
                >
                  <HomeIcon />
                  &nbsp; &nbsp; 18 Jaques Avenue Bondi Beach &nbsp; &nbsp;
                  <KeyboardArrowDownIcon />
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '40px',
                  justifyContent: 'start',
                }}
              >
                <Typography
                  sx={{
                    ...poppins400,
                    ...fontsize10,
                    color: '#666666',
                    whiteSpace: 'nowrap',
                  }}
                >
                  Campaign Timer
                </Typography>
                <Typography
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    fontFamily: 'poppins',
                    color: '#112347',
                    fontWeight: 400,
                  }}
                ></Typography>
              </Box>
              <Box>
                <Box>
                  <CountdownTimer />
                </Box>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'end',
                  gap: '40px',
                  marginLeft: 'auto',
                  marginRight: '60px',
                }}
              >
                <Box sx={{ marginBottom: '15px' }}>
                  <RayWhite />
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '40px',
                    justifyContent: 'start',
                  }}
                >
                  <Typography
                    sx={{
                      ...poppins400,
                      ...fontsize10,
                      color: '#666666',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    Vendors Agent
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '30px',
                    }}
                  >
                    <Box
                      sx={{
                        position: 'relative',
                        display: 'inline-flex',
                      }}
                    >
                      <Avatar
                        alt="Remy"
                        src={Dp}
                        style={{
                          width: '36px',
                          height: '37px',
                        }}
                      />
                    </Box>
                    <Box sx={{ position: 'relative' }}>
                      <Typography sx={imageCont}>
                        <Typography
                          sx={{
                            fontSize: '12px',
                            fontFamily: 'Poppins',
                            fontWeight: '400',
                            cursor: 'pointer',
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: '12px',
                              fontFamily: 'Poppins',
                              fontWeight: '400',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            Keil Glass
                          </Typography>
                        </Typography>
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '15px',
                      }}
                    >
                      <MessageNew />
                      <CallNew />
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Table>
          <Table sx={{ backgroundColor: 'rgba(76, 164, 214, 0.03)' }}>
            {[1, 2, 3].map((item, i) => (
              <Box
                sx={{
                  margin: '0 60px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '60px',
                  padding: '20px 0',
                  borderBottom: '1px solid lightgrey',
                  overflowX: 'auto',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '40px',
                    justifyContent: 'start',
                  }}
                >
                  {i == 0 ? (
                    <Typography
                      sx={{
                        ...poppins400,
                        fontSize: '14px',
                        fontWeight: 500,
                        color: '#6C2AD2',
                      }}
                    >
                      Interested Buyers
                    </Typography>
                  ) : null}
                  <Box
                    sx={{
                      padding: '20px 0',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                    }}
                  >
                    <input color="primary" type="checkbox" />
                    <Typography
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                      }}
                    >
                      <Box
                        sx={{
                          position: 'relative',
                          display: 'inline-flex',
                        }}
                      >
                        <Avatar
                          alt="Remy"
                          src={Dp}
                          style={{
                            width: '36px',
                            height: '37px',
                          }}
                        />
                      </Box>
                      <Box sx={{ position: 'relative' }}>
                        <Typography sx={imageCont}>
                          <Typography
                            sx={{
                              fontSize: '12px',
                              fontFamily: 'Poppins',
                              fontWeight: '400',
                              cursor: 'pointer',
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: '12px',
                                fontFamily: 'Poppins',
                                fontWeight: '400',
                                whiteSpace: 'nowrap',
                              }}
                            >
                              Keil Glass
                            </Typography>
                          </Typography>
                          &nbsp;
                          <KeyboardArrowDownIcon />
                        </Typography>
                      </Box>
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '40px',
                    justifyContent: 'start',
                    marginLeft: '100px',
                  }}
                >
                  <Typography
                    sx={{
                      ...poppins400,
                      ...fontsize10,
                      color: '#666666',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    Buyer Status
                  </Typography>
                  <Box
                    sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}
                  >
                    <Box
                      sx={{ cursor: 'pointer' }}
                      onClick={(event) =>
                        popOverFunc(
                          event,
                          'Property Inspected',
                          'This buyer has inspected this property'
                        )
                      }
                    >
                      <EyeIcon color="#666666" />
                    </Box>
                    <Box
                      sx={{ cursor: 'pointer' }}
                      onClick={(event) =>
                        popOverFunc(
                          event,
                          'Due Diligence',
                          'This buyer has not yet completed their due diligence for this property'
                        )
                      }
                    >
                      <Receipt color="#666666" />
                    </Box>
                    <Box
                      sx={{ cursor: 'pointer' }}
                      onClick={(event) =>
                        popOverFunc(
                          event,
                          's66W Certificate',
                          'When buying a property in New South Wales (NSW) Australia, after the exchange of contracts, there is usually a five day cooling off period prior to the contract becoming binding and enforceable. The cooling off period can be waived by having your solicitor issue a s66W certificate. By submitting a signed s66W certificate, later when the sale contract is signed by both parties it will be immediately binding without any cooling off period.' +
                            'It  is common practice for buyers to include a signed s66W during the offering process to strengthen their offers.'
                        )
                      }
                    >
                      <Timer color="#666666" />
                    </Box>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '40px',
                    justifyContent: 'start',
                  }}
                >
                  <Typography
                    sx={{
                      ...poppins400,
                      ...fontsize10,
                      color: '#666666',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    Contract Status
                  </Typography>
                  <Typography
                    onClick={(event) => pendingStatus(event)}
                    sx={{
                      background: '#F39800',
                      padding: '3px 40px',
                      color: 'white',
                      fontFamily: 'poppins',
                      borderRadius: '5px',
                      cursor: 'pointer',
                    }}
                  >
                    Pending
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '40px',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Typography
                    sx={{
                      ...poppins400,
                      ...fontsize10,
                      color: '#666666',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    Contract ETA
                  </Typography>
                  <Box sx={{ display: 'flex' }}>
                    <Warning />
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '40px',
                    justifyContent: 'start',
                  }}
                >
                  <Typography
                    sx={{
                      ...poppins400,
                      ...fontsize10,
                      color: '#666666',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    s66W Status
                  </Typography>
                  <Typography
                    sx={{
                      background: '#08A742',
                      padding: '3px 40px',
                      color: 'white',
                      fontFamily: 'poppins',
                      borderRadius: '5px',
                    }}
                  >
                    Completed
                  </Typography>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '40px',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Typography
                    sx={{
                      ...poppins400,
                      ...fontsize10,
                      color: '#666666',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    s66W ETA
                  </Typography>
                  <Box>
                    <Warning />
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '40px',
                    justifyContent: 'start',
                    marginLeft: 'auto',
                  }}
                >
                  <Typography
                    sx={{
                      ...poppins400,
                      ...fontsize10,
                      color: '#666666',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    Buyer Solicitor
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'end',
                      gap: '30px',
                      marginLeft: 'auto',
                    }}
                  >
                    <Box
                      sx={{
                        position: 'relative',
                        display: 'inline-flex',
                      }}
                    >
                      <Avatar
                        alt="Remy"
                        src={Dp}
                        style={{
                          width: '36px',
                          height: '37px',
                        }}
                      />
                    </Box>
                    <Box sx={{ position: 'relative' }}>
                      <Typography sx={imageCont}>
                        <Typography
                          sx={{
                            fontSize: '12px',
                            fontFamily: 'Poppins',
                            fontWeight: '400',
                            cursor: 'pointer',
                          }}
                        >
                          <Typography
                            sx={{
                              fontSize: '12px',
                              fontFamily: 'Poppins',
                              fontWeight: '400',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            Keil Glass
                          </Typography>
                        </Typography>
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '15px',
                      }}
                    >
                      <MessageNew />
                      <CallNew />
                    </Box>
                  </Box>
                </Box>
              </Box>
            ))}
          </Table>
        </Collapse>
      </TableCell>

      <Popover
        id={idCheck}
        open={openCheck}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        sx={{ borderRadius: '10px' }}
      >
        <Grid
          container
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '15px',
            minWidth: '400px',
            maxWidth: '540px',
            marginTop: '-20px',
          }}
        >
          <Grid sx={{ padding: '0 30px', marginTop: '50px' }}>
            <Typography
              sx={{
                color: '#6C2AD2',
                fontFamily: 'poppins',
                fontSize: '16px',
                fontWeight: 500,
              }}
            >
              {name}
            </Typography>
          </Grid>
          <Grid sx={{ padding: '0 30px' }}>
            <Typography
              sx={{
                color: '#112347',
                fontFamily: 'poppins',
                fontSize: '14px',
                fontWeight: 300,
              }}
            >
              {content}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Grid
              container
              justifyContent="space-between"
              alignItems={'center'}
              sx={{
                borderTop: '1px solid lightgrey',
                padding: '15px 20px',
                fontFamily: 'poppins',
                marginTop: '15px',
              }}
            >
              <Grid>
                <Typography
                  onClick={() => {
                    handleCloseCheck();
                    handleOpenHelpCenter();
                  }}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '5px',
                    color: '#112347',
                    fontFamily: 'poppins',
                    fontSize: '14px',
                    fontWeight: 400,
                    margin: 0,
                    cursor: 'pointer',
                  }}
                >
                  <InfoIcon />
                  Need Help ?
                </Typography>
              </Grid>
              <Grid>
                <Button
                  onClick={handleCloseCheck}
                  sx={{
                    padding: '10px 30px',
                    color: 'grey',
                    fontFamily: 'poppins',
                    border: '1px solid lightgrey',
                    textTransform: 'none',
                  }}
                  variant="outlined"
                >
                  Close
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Popover>
      <Popover
        id={idCheckPending}
        open={openCheckPendingS}
        anchorEl={anchorElPending}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        sx={{ borderRadius: '10px' }}
      >
        <Grid
          container
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '15px',
            marginTop: '-20px',
          }}
        >
          <Grid
            sx={{
              padding: '0 30px',
              marginTop: '50px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: '20px',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '10px',
              }}
            >
              <ContractReceipt />
              <Typography
                sx={{
                  color: '#666',
                  fontFamily: 'poppins',
                  fontSize: '16px',
                  fontWeight: 500,
                }}
              >
                Contract Status
              </Typography>
            </Box>
            <Typography
              sx={{
                background: '#F39800',
                padding: '1px 30px',
                color: 'white',
                fontFamily: 'poppins',
                borderRadius: '5px',
                fontWeight: 300,
              }}
            >
              Pending
            </Typography>
          </Grid>

          <Grid
            sx={{
              padding: '0 30px',
              marginTop: '20px',
              display: 'flex',
              alignItems: 'center',
              gap: '20px',
            }}
          >
            <Button
              sx={{
                background: '#6C2AD21A',
                padding: '10px 50px',
                border: '1px solid #6C2AD21A',
                fontFamily: 'poppins',
                color: '#6C2AD2',
              }}
              variant="outlined"
            >
              View
            </Button>
            <Button
              sx={{
                background: 'white',
                padding: '10px 50px',
                border: '1px solid lightgrey',
                fontFamily: 'poppins',
                color: 'grey',
              }}
              variant="outlined"
            >
              Discuss
            </Button>
          </Grid>

          <Grid
            sx={{
              padding: '0 30px',
              display: 'flex',
              alignItems: 'center',
              gap: '20px',
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <Clock />
              <Typography
                sx={{
                  color: '#666',
                  fontFamily: 'poppins',
                  fontSize: '16px',
                  fontWeight: 500,
                }}
              >
                ETA
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                border: '1px solid #4CA4D6',
              }}
            >
              <Calender />
              <input style={{ width: '220px', border: 'none' }} />
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Grid
              container
              justifyContent="space-between"
              alignItems={'end'}
              sx={{
                borderTop: '1px solid lightgrey',
                padding: '15px 20px',
                fontFamily: 'poppins',
                marginTop: '15px',
              }}
            >
              <Button
                onClick={handleCloseCheckPending}
                sx={{
                  padding: '10px 30px',
                  color: 'white',
                  fontFamily: 'poppins',
                  marginLeft: 'auto',
                  background: '#4CA4D6',
                  '&:hover': {
                    background: '#4CA4D6',
                  },
                }}
                variant="outlined"
              >
                Save
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Popover>
    </TableRow>
  );
}

export default BuyerSolicitor;
export { datacontextsoli };
